import { PLATFORM_ADMIN_ROLE_NAMES as e } from "@teletienda/shared-utils-lib";
import { create as t } from "zustand";
import { createJSONStorage as n, persist as r } from "zustand/middleware";
import i, { HTTPError as a } from "ky";
import { createContext as o, useCallback as s, useContext as c, useEffect as l, useMemo as u, useRef as d, useState as f } from "react";
import { Alert as p, Anchor as m, Avatar as h, Box as g, Button as _, Center as v, Checkbox as y, Code as b, Divider as x, Group as S, Loader as C, Menu as w, Modal as T, Paper as E, PasswordInput as D, Progress as O, SegmentedControl as ee, Stack as k, Text as A, TextInput as j, ThemeIcon as M, Title as N, UnstyledButton as P, useComputedColorScheme as te, useMantineTheme as ne } from "@mantine/core";
import { useForm as re } from "@mantine/form";
import { IconAlertCircle as F, IconArrowLeft as ie, IconBrandFacebook as ae, IconBrandGoogle as oe, IconBrandWhatsapp as se, IconCheck as ce, IconChevronDown as le, IconHome as ue, IconInfoCircle as de, IconLock as fe, IconLogout as pe, IconMail as me, IconShieldCheck as he, IconShoppingCart as ge, IconUser as _e, IconWallet as ve, IconX as ye } from "@tabler/icons-react";
import { z as I } from "zod";
import { useTranslation as L } from "react-i18next";
import { Fragment as R, jsx as z, jsxs as B } from "react/jsx-runtime";
import { useDisclosure as be, useMediaQuery as xe } from "@mantine/hooks";
import { notifications as Se } from "@mantine/notifications";
//#region src/utils/storage/authEnv.ts
var Ce = "teletienda.ar", we = `dev.${Ce}`;
function Te(e) {
	let t = e.trim().toLowerCase().replace(/\.$/, "");
	return t === "localhost" || t === "127.0.0.1" || t.endsWith(".teletienda.local") ? "local" : t === we || t.endsWith(`.${we}`) || t.endsWith(`.${Ce}`) && t.split(".")[0].startsWith("dev-") ? "dev" : "prod";
}
function Ee() {
	return Te(typeof window > "u" ? "" : window.location.hostname);
}
function De(e, t = Ee()) {
	return t === "prod" ? e : `${e}-${t}`;
}
//#endregion
//#region src/utils/storage/config.ts
var Oe = "teletienda-auth", ke = `${Oe}:shared-cookie-ok`, Ae = "teletienda-auth-sync", je = "tt-auth-sync";
function Me(e) {
	return De(je, e);
}
var Ne = 2e3, Pe = 720 * 60 * 60, Fe = ".teletienda.ar", Ie = null;
function Le() {
	return typeof window > "u" ? !1 : window.location.hostname.endsWith(".teletienda.ar");
}
function Re() {
	if (typeof window > "u") return "localhost";
	let e = window.location.hostname;
	return e.endsWith(".teletienda.ar") ? Fe : e.endsWith(".teletienda.local") ? ".teletienda.local" : e;
}
function ze() {
	let e = Le() || typeof window < "u" && window.location.protocol === "https:";
	return {
		cookieDomain: Re(),
		secure: e,
		sameSite: "lax",
		maxAge: Pe,
		storageKey: Oe
	};
}
function Be() {
	return Ie ||= ze(), Ie;
}
function Ve(e) {
	Ie = {
		...ze(),
		...e
	};
}
function He() {
	Ie = null;
}
//#endregion
//#region src/utils/storage/cookies.ts
function Ue() {
	let e = /* @__PURE__ */ new Map();
	if (typeof document > "u") return e;
	let t = document.cookie.split(";");
	for (let n of t) {
		let [t, ...r] = n.split("=");
		if (t) {
			let n = t.trim(), i = r.join("=").trim();
			if (n) try {
				e.set(n, decodeURIComponent(i));
			} catch {
				e.set(n, i);
			}
		}
	}
	return e;
}
function V(e) {
	return Ue().get(e) ?? null;
}
function We(e, t, n) {
	if (typeof document > "u") return;
	let r = Be(), i = {
		domain: n?.domain ?? r.cookieDomain,
		path: n?.path ?? "/",
		maxAge: n?.maxAge ?? r.maxAge,
		secure: n?.secure ?? r.secure,
		sameSite: n?.sameSite ?? r.sameSite
	}, a = [
		`${encodeURIComponent(e)}=${encodeURIComponent(t)}`,
		`path=${i.path}`,
		`max-age=${i.maxAge}`,
		`samesite=${i.sameSite}`
	];
	i.domain && i.domain !== "localhost" && a.push(`domain=${i.domain}`), i.secure && a.push("secure"), document.cookie = a.join("; ");
}
function Ge(e, t) {
	if (typeof document > "u") return;
	let n = Be(), r = t ?? n.cookieDomain, i = [
		`${encodeURIComponent(e)}=`,
		"path=/",
		"max-age=0",
		"expires=Thu, 01 Jan 1970 00:00:00 GMT"
	];
	r && r !== "localhost" && i.push(`domain=${r}`), document.cookie = i.join("; ");
}
function Ke() {
	if (typeof document > "u") return !1;
	try {
		let e = "__tt_cookie_test__";
		document.cookie = `${e}=1; path=/`;
		let t = document.cookie.includes(e);
		return document.cookie = `${e}=; path=/; max-age=0`, t;
	} catch {
		return !1;
	}
}
function qe(e, t, n) {
	We(e, JSON.stringify(t), n);
}
function Je(e) {
	let t = V(e);
	if (!t) return null;
	try {
		return JSON.parse(t);
	} catch {
		return null;
	}
}
//#endregion
//#region src/utils/storage/crossTabSync.ts
var Ye = class {
	channel = null;
	handlers = /* @__PURE__ */ new Set();
	useFallback = !1;
	boundStorageHandler = null;
	constructor() {
		this.init();
	}
	init() {
		if (!(typeof window > "u")) {
			if ("BroadcastChannel" in window) try {
				this.channel = new BroadcastChannel(Ae), this.channel.onmessage = (e) => {
					this.notifyHandlers(e.data);
				};
				return;
			} catch {}
			this.useFallback = !0, this.boundStorageHandler = this.handleStorageEvent.bind(this), window.addEventListener("storage", this.boundStorageHandler);
		}
	}
	handleStorageEvent(e) {
		if (e.key === "teletienda-auth-sync" && e.newValue) try {
			let t = JSON.parse(e.newValue);
			this.notifyHandlers(t);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Sync handler error:", e);
		}
	}
	subscribe(e) {
		return this.handlers.add(e), () => {
			this.handlers.delete(e);
		};
	}
	broadcast(e, t) {
		let n = {
			type: e,
			timestamp: Date.now(),
			data: t
		};
		if (this.channel) this.channel.postMessage(n);
		else if (this.useFallback && typeof localStorage < "u") try {
			localStorage.setItem(`${Oe}-sync`, JSON.stringify(n)), localStorage.removeItem(`${Oe}-sync`);
		} catch {}
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.channel &&= (this.channel.close(), null), this.boundStorageHandler && typeof window < "u" && (window.removeEventListener("storage", this.boundStorageHandler), this.boundStorageHandler = null), this.handlers.clear();
	}
	isUsingBroadcastChannel() {
		return this.channel !== null;
	}
}, Xe = null;
function Ze() {
	return Xe ||= new Ye(), Xe;
}
function Qe() {
	Xe &&= (Xe.destroy(), null);
}
function $e(e) {
	return Ze().subscribe(e);
}
function et() {
	Ze().broadcastLogin();
}
function tt() {
	Ze().broadcastLogout();
}
function nt() {
	Ze().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/crossSubdomainSync.ts
var rt = class {
	handlers = /* @__PURE__ */ new Set();
	pollInterval = null;
	lastSeenTimestamp = 0;
	currentOrigin = "";
	constructor() {
		typeof window < "u" && (this.currentOrigin = window.location.origin, this.initializeFromCookie());
	}
	initializeFromCookie() {}
	getPendingEvent() {
		let e = V(Me());
		if (!e) return null;
		try {
			let t = JSON.parse(e);
			return t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp ? null : t;
		} catch {
			return null;
		}
	}
	startPolling() {
		this.pollInterval || typeof window > "u" || (this.pollInterval = setInterval(() => {
			this.checkForChanges();
		}, Ne));
	}
	stopPolling() {
		this.pollInterval &&= (clearInterval(this.pollInterval), null);
	}
	checkForChanges() {
		let e = V(Me());
		if (e) try {
			let t = JSON.parse(e);
			if (t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp) return;
			this.lastSeenTimestamp = t.timestamp;
			let n = {
				type: t.type,
				timestamp: t.timestamp
			};
			this.notifyHandlers(n);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Cross-subdomain sync handler error:", e);
		}
	}
	subscribe(e) {
		if (this.handlers.add(e), this.handlers.size === 1) {
			this.startPolling();
			let t = this.getPendingEvent();
			t && (this.lastSeenTimestamp = t.timestamp, setTimeout(() => {
				e({
					type: t.type,
					timestamp: t.timestamp
				});
			}, 0));
		}
		return () => {
			this.handlers.delete(e), this.handlers.size === 0 && this.stopPolling();
		};
	}
	broadcast(e) {
		if (typeof window > "u") return;
		let t = {
			type: e,
			timestamp: Date.now(),
			origin: this.currentOrigin
		};
		this.lastSeenTimestamp = t.timestamp, We(Me(), JSON.stringify(t), { maxAge: 300 });
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.stopPolling(), this.handlers.clear();
	}
	isPolling() {
		return this.pollInterval !== null;
	}
}, it = null;
function at() {
	return it ||= new rt(), it;
}
function ot() {
	it &&= (it.destroy(), null);
}
function st(e) {
	return at().subscribe(e);
}
function ct() {
	at().broadcastLogin();
}
function lt() {
	at().broadcastLogout();
}
function ut() {
	at().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/slimCookieStorage.ts
var dt = "tt-auth-slim";
function ft(e) {
	return De(dt, e);
}
var pt = 3072, mt = 4096;
function ht(e) {
	if (!e || typeof e != "object") return !1;
	let t = e;
	return typeof t.token == "string" && typeof t.refreshToken == "string" && typeof t.userGuid == "string" && typeof t.isAuthenticated == "boolean" && typeof t.expiresAt == "number" && (t.env === void 0 || typeof t.env == "string");
}
function gt(e) {
	return e.env === void 0;
}
function _t(e) {
	return typeof Blob < "u" ? new Blob([e]).size : new TextEncoder().encode(e).length;
}
function vt() {
	let e = V(ft()), t = e ? _t(e) : 0;
	return {
		currentSize: t,
		maxSize: mt,
		warningThreshold: pt,
		isOverWarning: t > pt,
		isOverLimit: t > mt,
		percentUsed: Math.round(t / mt * 100)
	};
}
function yt(e) {
	let t = JSON.stringify({
		...e,
		env: Ee()
	}), n = _t(t);
	if (n > 4096) return console.error(`[SlimCookie] Cookie size (${n} bytes) exceeds maximum (${mt} bytes). Cookie will NOT be set to prevent silent browser rejection.`), !1;
	n > 3072 && console.warn(`[SlimCookie] Cookie size (${n} bytes) exceeds warning threshold (${pt} bytes). Consider reducing stored data.`);
	let r = ft();
	return We(r, t), V(r) === t;
}
function H() {
	let e = V(ft());
	if (!e) return null;
	try {
		let t = JSON.parse(e);
		return ht(t) ? t.env !== void 0 && t.env !== Ee() ? null : t : (console.warn("[SlimCookie] Cookie contains invalid SlimAuthData structure"), null);
	} catch (e) {
		return console.warn("[SlimCookie] Failed to parse cookie JSON:", e), null;
	}
}
function bt() {
	return V(ft()) !== null;
}
function xt() {
	Ge(ft());
}
//#endregion
//#region src/api/config.ts
var U = { timeout: 3e4 }, St = null;
function Ct(e) {
	return e && e.length > 0 ? e : (console.error("[shared-auth-ui] baseUrl is not declared: pass apiBaseUrl / configureAuthApi({baseUrl}). Falling back to \"/\" — on a merchant app this is the WRONG service."), "/");
}
function wt(e) {
	U = {
		...U,
		...e
	}, St = i.create({
		prefixUrl: Ct(U.baseUrl),
		timeout: U.timeout,
		hooks: { beforeRequest: [(e) => {
			if (U.getToken) {
				let t = U.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	});
}
function W() {
	return St ||= i.create({
		prefixUrl: Ct(U.baseUrl),
		timeout: U.timeout,
		hooks: { beforeRequest: [(e) => {
			if (U.getToken) {
				let t = U.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	}), St;
}
function Tt() {
	return { ...U };
}
function Et(e) {
	U.getToken = e;
}
//#endregion
//#region src/utils/transformApiUser.ts
function G(e) {
	return {
		userGuid: e.user_guid,
		email: e.email || e.notification_email || e.notificationEmail,
		name: e.display_name || e.first_name || e.email?.split("@")[0] || "",
		firstName: e.first_name,
		lastName: e.last_name,
		phone: e.phone,
		avatarUrl: e.avatar || e.avatar_url,
		roles: e.roles || [],
		permissions: e.permissions || [],
		merchantGuid: e.merchant_guid,
		merchantGuids: e.merchant_guids,
		preferred_currency: e.preferred_currency,
		languageCode: e.language_code
	};
}
//#endregion
//#region src/utils/storage/authStorage.ts
function Dt() {
	let e = {
		localStorage: !1,
		cookies: !1,
		broadcastChannel: !1,
		slimCookieSize: 0,
		slimCookieHealthy: !0
	};
	if (typeof window < "u" && window.localStorage) try {
		let t = "__tt_storage_test__";
		localStorage.setItem(t, "1"), localStorage.removeItem(t), e.localStorage = !0;
	} catch {}
	e.cookies = Ke(), typeof window < "u" && "BroadcastChannel" in window && (e.broadcastChannel = !0);
	let t = vt();
	return e.slimCookieSize = t.currentSize, e.slimCookieHealthy = !t.isOverWarning, e;
}
function Ot() {
	if (typeof window > "u") return !1;
	try {
		let e = "__tt_private_test__";
		return localStorage.setItem(e, "1"), localStorage.removeItem(e), "storage" in navigator && "estimate" in navigator.storage, !1;
	} catch {
		return !0;
	}
}
function kt(e) {
	let t = Be();
	return e === t.storageKey || e.startsWith(t.storageKey) ? e : `${t.storageKey}-${e}`;
}
async function At(e) {
	try {
		let t = await W().get("api/v1/users/me", { headers: { Authorization: `Bearer ${e}` } }).json();
		return t.success && t.data ? {
			status: "ok",
			user: G(t.data)
		} : (console.warn("[AuthStorage] hydrateFromApi: Invalid response format"), { status: "error" });
	} catch (e) {
		return e instanceof Error && e.message.includes("401") ? { status: "unauthorized" } : (console.warn("[AuthStorage] hydrateFromApi failed:", e), { status: "error" });
	}
}
function jt(e) {
	if (!e || typeof e != "object") return !1;
	let t = e.user;
	return t ? Array.isArray(t.roles) && Array.isArray(t.permissions) && typeof t.email == "string" : !1;
}
function Mt() {
	let e = kt(Be().storageKey);
	if (typeof window < "u" && window.localStorage) try {
		let t = localStorage.getItem(e);
		if (t && jt(JSON.parse(t)?.state)) return !1;
	} catch {}
	let t = H();
	return t !== null && t.isAuthenticated;
}
var K = null, Nt = !1;
function q(e) {
	K = e;
}
function Pt() {
	K = null;
}
function Ft() {
	return K;
}
function It() {
	Nt = !0, K = null;
}
function Lt() {
	Nt = !1;
}
function Rt(e) {
	if (!e || !bt()) return !1;
	let t = H();
	return !t || t.refreshToken !== e ? !1 : (xt(), K === e && (K = null), !0);
}
function zt() {
	try {
		return localStorage.getItem(ke) === "true";
	} catch {
		return !1;
	}
}
function Bt(e) {
	try {
		localStorage.setItem(ke, e ? "true" : "false");
	} catch {}
}
function Vt(e) {
	return JSON.stringify({
		state: {
			user: { userGuid: e.userGuid },
			token: e.token,
			refreshToken: e.refreshToken,
			expiresAt: e.expiresAt,
			isAuthenticated: !0,
			isLoading: !1,
			_needsHydration: !0
		},
		version: 0
	});
}
var Ht = {
	state: {
		user: null,
		token: null,
		refreshToken: null,
		expiresAt: null,
		isAuthenticated: !1,
		isLoading: !1
	},
	version: 0
}, Ut = class {
	cookiesAvailable;
	localStorageAvailable;
	constructor() {
		let e = Dt();
		this.cookiesAvailable = e.cookies, this.localStorageAvailable = e.localStorage, !this.cookiesAvailable && this.localStorageAvailable && Bt(!1), !this.localStorageAvailable && !this.cookiesAvailable ? console.warn("[shared-auth-ui] No storage available. Auth state will not persist.") : this.cookiesAvailable || console.warn("[shared-auth-ui] Cookies disabled. Cross-subdomain SSO will not work.");
	}
	getItem(e) {
		let t = kt(e), n = null;
		if (this.localStorageAvailable) try {
			n = localStorage.getItem(t);
		} catch {}
		let r = null;
		if (n !== null) try {
			r = JSON.parse(n)?.state ?? null;
		} catch {}
		let i = r?.isAuthenticated === !0;
		if (!this.cookiesAvailable) return n;
		let a = H(), o = !!a && a.isAuthenticated && !!a.token;
		if (!i) return o ? (q(a.refreshToken), Vt(a)) : n;
		if (o) return a.refreshToken === r?.refreshToken ? (q(a.refreshToken), n) : gt(a) ? n : (q(a.refreshToken), Vt(a));
		let s = !!a && !a.isAuthenticated && !gt(a), c = !a && zt();
		if (s || c) {
			if (this.localStorageAvailable) try {
				localStorage.setItem(t, JSON.stringify(Ht));
			} catch {}
			return JSON.stringify(Ht);
		}
		return n;
	}
	setItem(e, t) {
		let n = kt(e);
		if (this.localStorageAvailable) try {
			localStorage.setItem(n, t);
		} catch (e) {
			if (this.isQuotaExceededError(e)) {
				this.handleQuotaExceeded();
				try {
					localStorage.setItem(n, t);
				} catch {}
			}
		}
		if (this.cookiesAvailable) try {
			let e = JSON.parse(t)?.state, n = e?.user?.userGuid;
			if (e?.token && n) {
				if (!e.expiresAt || !e.refreshToken || e.refreshToken !== K) return;
				Bt(yt({
					token: e.token,
					refreshToken: e.refreshToken,
					userGuid: n,
					isAuthenticated: e.isAuthenticated ?? !0,
					expiresAt: e.expiresAt
				}));
			} else !e?.isAuthenticated && Nt && xt();
		} catch {}
	}
	removeItem(e) {
		let t = kt(e);
		if (this.localStorageAvailable) try {
			localStorage.removeItem(t);
		} catch {}
		this.cookiesAvailable && (Ge(t), Nt && xt());
	}
	clear() {
		let e = Be();
		if (this.localStorageAvailable) try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
		this.cookiesAvailable && (Ge(e.storageKey), Ge(`${e.storageKey}-sync`), Nt && xt()), tt();
	}
	isQuotaExceededError(e) {
		return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED");
	}
	handleQuotaExceeded() {
		console.warn("[shared-auth-ui] Storage quota exceeded. Clearing old data.");
		let e = Be();
		try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && r !== e.storageKey && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
	}
	getHealth() {
		let e = vt();
		return {
			localStorage: this.localStorageAvailable,
			cookies: this.cookiesAvailable,
			broadcastChannel: typeof window < "u" && "BroadcastChannel" in window,
			slimCookieSize: e.currentSize,
			slimCookieHealthy: !e.isOverWarning
		};
	}
	notifyLogin() {
		et(), ct();
	}
	notifyLogout() {
		tt(), lt();
	}
	notifyTokenRefresh() {
		nt(), ut();
	}
}, Wt = null;
function J() {
	return Wt ||= new Ut(), Wt;
}
function Gt() {
	Wt = null, K = null, Nt = !1;
}
function Kt() {
	return J();
}
//#endregion
//#region src/store/authStore.ts
var qt = Oe, Jt = {
	user: null,
	token: null,
	refreshToken: null,
	expiresAt: null,
	isAuthenticated: !1,
	isLoading: !1
}, Yt = null;
function Xt(e) {
	Yt = e;
}
function Zt() {
	return Yt || Kt();
}
var Qt = (t, n) => ({
	...Jt,
	login: (e, n, r, i) => {
		let a = Date.now() + r * 1e3;
		q(n), t({
			token: e,
			refreshToken: n,
			expiresAt: a,
			user: i,
			isAuthenticated: !0,
			isLoading: !1
		}), J().notifyLogin();
	},
	logout: () => {
		It();
		try {
			t(Jt), xt(), J().notifyLogout();
		} finally {
			Lt();
		}
	},
	updateToken: (e, r, i) => {
		let a = Date.now() + r * 1e3, o = i ?? n().refreshToken;
		o && q(o), t({
			token: e,
			expiresAt: a,
			...i && { refreshToken: i }
		}), J().notifyTokenRefresh();
	},
	updateUser: (e) => {
		t({ user: e });
	},
	setLoading: (e) => {
		t({ isLoading: e });
	},
	hasRole: (e) => {
		let { user: t } = n();
		return t ? t.roles.includes(e) : !1;
	},
	hasAnyRole: (e) => {
		let { user: t } = n();
		return t ? e.some((e) => t.roles.includes(e)) : !1;
	},
	hasPermission: (t) => {
		let { user: r } = n();
		return r ? e.some((e) => r.roles.includes(e)) ? !0 : r.permissions.includes(t) : !1;
	}
}), $t = {
	name: qt,
	storage: n(() => Zt()),
	partialize: (e) => ({
		user: e.user,
		token: e.token,
		refreshToken: e.refreshToken,
		expiresAt: e.expiresAt,
		isAuthenticated: e.isAuthenticated
	})
}, Y = t()(r(Qt, $t)), en = !1;
async function tn(e, t = 3, n = !1) {
	for (let r = 0; r < t; r++) {
		if (await Y.persist.rehydrate(), Y.getState().isAuthenticated === e) return;
		!n && r < t - 1 && await new Promise((e) => setTimeout(e, 500 * 2 ** r));
	}
	console.warn("[shared-auth-ui] Rehydrate retry exhausted, state may be stale");
}
function nn(e) {
	return !!e && e.isAuthenticated && !!e.token && !gt(e);
}
function rn() {
	let e = H();
	if (!e?.isAuthenticated || !e?.token) return !1;
	let t = Y.getState();
	return t.isAuthenticated && t.refreshToken !== e.refreshToken ? gt(e) ? !1 : (console.debug("[shared-auth-ui] Session mismatch with cookie - forcing hydration"), !0) : !(t.isAuthenticated && t.user && Array.isArray(t.user.roles) && t.user.roles.length > 0);
}
async function an() {
	let e = H();
	if (!e?.token || !e?.isAuthenticated) return;
	let t = Y.getState(), n = t.refreshToken === e.refreshToken;
	if (!(t.isAuthenticated && t.user?.roles?.length && n) && !(t.isAuthenticated && !n && gt(e))) {
		console.debug("[shared-auth-ui] Performing initial hydration from slim cookie"), q(e.refreshToken), Y.setState({
			token: e.token,
			refreshToken: e.refreshToken,
			expiresAt: e.expiresAt,
			isAuthenticated: !0,
			isLoading: !0,
			user: null
		});
		try {
			let t = await At(e.token);
			t.status === "ok" ? (Y.setState({
				user: t.user,
				isLoading: !1
			}), console.debug("[shared-auth-ui] Initial hydration successful")) : t.status === "unauthorized" ? (ln(e.refreshToken), console.debug("[shared-auth-ui] Initial hydration failed - token rejected (401)")) : (Pt(), Y.setState(Jt), console.debug("[shared-auth-ui] Initial hydration deferred - transient error, slim cookie preserved"));
		} catch (e) {
			console.warn("[shared-auth-ui] Initial hydration error:", e), Pt(), Y.setState(Jt);
		}
	}
}
async function on() {
	rn() && await an();
}
function sn() {
	if (en) return console.debug("[shared-auth-ui] Sync already initialized"), () => {};
	en = !0, rn() && an();
	let e = async (e) => {
		let t = Y.getState();
		switch (e.type) {
			case "logout": {
				let e = H();
				if (nn(e) && e.refreshToken !== t.refreshToken) {
					await cn(e);
					break;
				}
				t.isAuthenticated && (Pt(), Y.setState(Jt)), Rt(t.refreshToken), setTimeout(() => tn(!1), 500);
				break;
			}
			case "login": {
				let e = H();
				if (!e?.token || !e?.isAuthenticated) {
					console.debug("[shared-auth-ui] Cross-subdomain login: no slim cookie, retrying"), setTimeout(() => tn(!0), 500);
					return;
				}
				if (e.refreshToken === t.refreshToken || t.isAuthenticated && gt(e)) break;
				await cn(e);
				break;
			}
			case "token_refresh": {
				let e = H();
				nn(e) && e.refreshToken !== t.refreshToken ? t.isAuthenticated && t.user?.userGuid === e.userGuid ? (q(e.refreshToken), Y.setState({
					token: e.token,
					refreshToken: e.refreshToken,
					expiresAt: e.expiresAt
				})) : await cn(e) : e?.token && e.refreshToken === t.refreshToken && Y.setState({
					token: e.token,
					expiresAt: e.expiresAt
				}), setTimeout(() => Y.persist.rehydrate(), 500);
				break;
			}
		}
	}, t = $e(e), n = st(e);
	return () => {
		en = !1, t(), n();
	};
}
async function cn(e) {
	console.debug("[shared-auth-ui] Adopting session from cookie: validating token first"), Y.setState({ isLoading: !0 });
	try {
		let t = await At(e.token);
		if (t.status === "ok") return q(e.refreshToken), Y.setState({
			token: e.token,
			refreshToken: e.refreshToken,
			expiresAt: e.expiresAt,
			isAuthenticated: !0,
			isLoading: !1,
			user: t.user
		}), !0;
		t.status === "unauthorized" ? (console.warn("[shared-auth-ui] Cookie session rejected (401)"), Rt(e.refreshToken)) : console.warn("[shared-auth-ui] Cookie session not validated: transient error, slim cookie preserved");
	} catch (e) {
		console.warn("[shared-auth-ui] Cookie session not validated: API error", e);
	}
	return Y.setState({ isLoading: !1 }), !1;
}
function ln(e) {
	Pt(), Y.setState(Jt), Rt(e) && J().notifyLogout();
}
function un() {
	let e = H();
	if (nn(e) && e.refreshToken) return {
		refreshToken: e.refreshToken,
		userGuid: e.userGuid
	};
	let t = Y.getState();
	return {
		refreshToken: t.refreshToken,
		userGuid: t.user?.userGuid ?? null
	};
}
function dn(e, t) {
	let { user: n } = Y.getState();
	!e || n?.userGuid === e || At(t).then((e) => {
		e.status === "ok" && Y.getState().token === t && Y.setState({ user: e.user });
	});
}
function fn(e) {
	let t = H();
	if (nn(t) && t.refreshToken !== e) {
		let e = Y.getState().user?.userGuid === t.userGuid;
		return q(t.refreshToken), Y.setState({
			token: t.token,
			refreshToken: t.refreshToken,
			expiresAt: t.expiresAt,
			isAuthenticated: !0
		}), e || dn(t.userGuid, t.token), console.debug("[shared-auth-ui] Refresh rejected - switched to the live session from cookie"), t.token;
	}
	return ln(e), null;
}
function pn() {
	let { expiresAt: e } = Y.getState();
	return e ? Date.now() >= e - 120 * 1e3 : !1;
}
function mn() {
	let { expiresAt: e } = Y.getState();
	return e ? Date.now() >= e : !0;
}
function hn() {
	J().clear();
}
function gn() {
	return J().getHealth();
}
//#endregion
//#region src/store/sessionPending.ts
function _n(e) {
	return e.isAuthenticated && !(e.user && Array.isArray(e.user.roles));
}
//#endregion
//#region src/api/authApi.ts
var X = class extends Error {
	code;
	status;
	details;
	constructor(e, t, n, r) {
		super(e), this.name = "AuthApiError", this.code = t, this.status = n, this.details = r;
	}
};
async function vn(e) {
	if (e instanceof a) try {
		let t = await e.response.json();
		throw new X(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
	} catch (t) {
		throw t instanceof X ? t : new X(e.message, "HTTP_ERROR", e.response.status);
	}
	throw e instanceof Error ? new X(e.message, "NETWORK_ERROR", 0) : new X("Unknown error", "UNKNOWN_ERROR", 0);
}
async function yn(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/login", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Login failed", n.error?.code || "LOGIN_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
async function bn(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/register", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Registration failed", n.error?.code || "REGISTRATION_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
async function xn(e) {
	let t = W();
	try {
		let n = { refreshToken: e }, r = await t.post("api/v1/auth/refresh-token", { json: n }).json();
		if (!r.success || !r.data) throw new X(r.error?.message || "Token refresh failed", r.error?.code || "REFRESH_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
async function Sn(e) {
	let t = W();
	try {
		let n = { refreshToken: e };
		await t.post("api/v1/auth/logout", {
			json: n,
			timeout: 5e3
		});
	} catch {}
}
async function Cn(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/request-login-code", { json: { email: e } }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Failed to request login code", n.error?.code || "REQUEST_CODE_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
async function wn(e, t) {
	let n = W();
	try {
		let r = await n.post("api/v1/auth/login-by-code", { json: {
			email: e,
			code: t
		} }).json();
		if (!r.success || !r.data) throw new X(r.error?.message || "Login by code failed", r.error?.code || "LOGIN_BY_CODE_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
async function Tn(e) {
	let t = W();
	try {
		let n = await t.get("api/v1/users/me", {
			headers: { Authorization: `Bearer ${e}` },
			timeout: 1e4
		}).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Failed to fetch user profile", n.error?.code || "PROFILE_FETCH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
var En = 1e4;
async function Dn(e, t) {
	try {
		let n = await e();
		if (!n.success || !n.data) throw new X(n.error?.message || t.message, n.error?.code || t.code, 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return vn(e);
	}
}
function On() {
	let e = W();
	return Dn(() => e.post("api/v1/auth/sessions/current/activity", { timeout: En }).json(), {
		message: "Failed to record activity",
		code: "ACTIVITY_FAILED"
	});
}
function kn() {
	let e = W();
	return Dn(() => e.get("api/v1/auth/session-policy", { timeout: En }).json(), {
		message: "Failed to load the session policy",
		code: "SESSION_POLICY_FAILED"
	});
}
function An(e) {
	let t = W();
	return Dn(() => t.put("api/v1/auth/session-policy", {
		json: { idleTimeoutMinutes: e },
		timeout: En
	}).json(), {
		message: "Failed to update the session policy",
		code: "SESSION_POLICY_UPDATE_FAILED"
	});
}
//#endregion
//#region src/store/idleStore.ts
function jn(e) {
	if (!e) return null;
	let t = Date.parse(e);
	return Number.isNaN(t) ? null : t;
}
var Mn = t()((e) => ({
	deadline: null,
	clockOffsetMs: 0,
	setDeadline: (t, n) => e((e) => {
		let r = jn(n);
		return {
			deadline: jn(t),
			clockOffsetMs: r === null ? e.clockOffsetMs : r - Date.now()
		};
	}),
	clear: () => e({
		deadline: null,
		clockOffsetMs: 0
	})
}));
function Nn() {
	return Date.now() + Mn.getState().clockOffsetMs;
}
//#endregion
//#region src/api/httpClient.ts
var Pn = null, Z = [];
function Fn() {
	Pn = null, Z.length = 0;
}
async function Q(e) {
	if (Pn) return Pn;
	let { refreshToken: t, userGuid: n } = un();
	if (!t) throw ln(null), e?.({ code: "NO_REFRESH_TOKEN" }), new X("No refresh token", "NO_REFRESH_TOKEN", 401);
	return Pn = (async () => {
		try {
			let e = await xn(t);
			Y.getState().updateToken(e.accessToken, e.expiresIn, e.refreshToken ?? t), dn(n, e.accessToken);
			let r = e.accessToken;
			return Z.forEach(({ resolve: e }) => e(r)), Z.length = 0, r;
		} catch (n) {
			if (n instanceof X && n.status === 401) {
				console.warn(`[shared-auth-ui] Refresh rejected: ${n.code}`);
				let r = fn(t);
				if (r) return Z.forEach(({ resolve: e }) => e(r)), Z.length = 0, r;
				e?.({ code: n.code });
			}
			throw Z.forEach(({ reject: e }) => e(n)), Z.length = 0, n;
		} finally {
			Pn = null;
		}
	})(), Pn;
}
var In;
function Ln(e) {
	In = e;
}
async function Rn(e, t = In) {
	try {
		return await e();
	} catch (n) {
		if (!(n instanceof X) || n.status !== 401) throw n;
		if (n.code === "SESSION_IDLE") throw await Q(t).catch(() => void 0), n;
		return await Q(t), e();
	}
}
var zn = 30 * 1e3;
async function Bn(e) {
	let t = Y.getState();
	if (!t.isAuthenticated) return null;
	let { refreshToken: n } = un();
	if (n && n !== t.refreshToken) try {
		return await Q(Wn.onSessionExpired);
	} catch {
		return null;
	}
	if (!(e?.rejectedToken && e.rejectedToken === t.token) && t.token && t.expiresAt && Date.now() < t.expiresAt - zn) return t.token;
	try {
		return await Q(Wn.onSessionExpired);
	} catch {
		return null;
	}
}
function Vn() {
	return new Promise((e, t) => {
		Z.push({
			resolve: e,
			reject: t
		});
	});
}
function Hn(e = {}) {
	let { baseUrl: t, timeout: n = 3e4, onSessionExpired: r } = e;
	return i.create({
		prefixUrl: t,
		timeout: n,
		hooks: {
			beforeRequest: [async (e) => {
				if (Pn) try {
					let t = await Vn();
					e.headers.set("Authorization", `Bearer ${t}`);
					return;
				} catch {}
				let t = Y.getState().token;
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}],
			afterResponse: [async (e, t, n) => {
				if (n.status !== 401 || e.url.includes("/auth/refresh") || e.url.includes("/auth/login")) return n;
				try {
					let n = await Q(r), a = new Headers(e.headers);
					a.set("Authorization", `Bearer ${n}`);
					let o = {
						...t,
						headers: a
					};
					return i(e.url, o);
				} catch {
					return n;
				}
			}]
		}
	});
}
var Un = null, Wn = {};
function Gn(e) {
	Wn = e, Un = Hn(e);
}
function Kn() {
	return Un ||= Hn(Wn), Un;
}
async function qn(e, t) {
	let n = Kn();
	try {
		return await n(e, t).json();
	} catch (e) {
		if (e instanceof a) {
			let t = await e.response.json().catch(() => ({}));
			throw new X(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
		}
		throw e;
	}
}
//#endregion
//#region src/api/sessionPolicy.ts
async function Jn(e = {}) {
	let t = await Rn(() => On(), e.onSessionExpired);
	return Mn.getState().setDeadline(t.idleDeadline, t.serverTime), t;
}
async function Yn(e = {}) {
	let t = await Rn(() => kn(), e.onSessionExpired);
	return Mn.getState().setDeadline(t.idleDeadline, t.serverTime), t;
}
async function Xn(e, t = {}) {
	let n = await Rn(() => An(e), t.onSessionExpired);
	return Mn.getState().setDeadline(n.idleDeadline, n.serverTime), n;
}
//#endregion
//#region src/api/channelClaimApi.ts
async function Zn(e, t) {
	let n = await e;
	if (!n.success || !n.data) throw new X(n.error?.message || "Channel claim failed", n.error?.code || t, 400, n.error?.details);
	return n.data;
}
async function Qn(e) {
	let t = W();
	try {
		return await Zn(t.post("api/v1/auth/channel-claim/start", { json: {
			merchant_guid: e,
			channel: "whatsapp"
		} }).json(), "CHANNEL_CLAIM_START_FAILED");
	} catch (e) {
		throw e instanceof X ? e : new X("Could not start WhatsApp login", "CHANNEL_CLAIM_START_FAILED", 503);
	}
}
async function $n(e) {
	return Zn(W().get(`api/v1/auth/channel-claim/${encodeURIComponent(e)}`).json(), "CHANNEL_CLAIM_POLL_FAILED");
}
async function er(e) {
	return Zn(W().post(`api/v1/auth/channel-claim/${encodeURIComponent(e)}/accept`).json(), "CHANNEL_CLAIM_ACCEPT_FAILED");
}
//#endregion
//#region src/api/oauthApi.ts
async function tr(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/google/callback", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Google OAuth failed", n.error?.code || "GOOGLE_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Google");
	}
}
async function nr(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/google/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Google OIDC start failed", n.error?.code || "GOOGLE_OIDC_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Google");
	}
}
async function rr(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/link/google/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Google OIDC link start failed", n.error?.code || "GOOGLE_OIDC_LINK_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Google");
	}
}
async function ir(e, t) {
	let n = W();
	try {
		let r = await n.post("api/v1/oauth/google/oidc/callback", { json: {
			code: e,
			state: t
		} }).json();
		if (!r.success || !r.data) throw new X(r.error?.message || "Google OIDC callback failed", r.error?.code || "GOOGLE_OIDC_CALLBACK_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Google");
	}
}
async function ar(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/facebook/callback", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Facebook OAuth failed", n.error?.code || "FACEBOOK_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Facebook");
	}
}
async function or(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/telegram/oidc/start", { json: e ? { returnUrl: e } : {} }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Telegram OIDC start failed", n.error?.code || "TELEGRAM_OIDC_START_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Telegram");
	}
}
async function sr(e, t) {
	let n = W(), r = {};
	e && (r.returnUrl = e), t?.requestBotAccess && (r.requestBotAccess = !0);
	try {
		let e = await n.post("api/v1/auth/link/telegram/oidc/start", { json: r }).json();
		if (!e.success || !e.data) throw new X(e.error?.message || "Telegram OIDC link start failed", e.error?.code || "TELEGRAM_OIDC_LINK_START_FAILED", 400, e.error?.details);
		return e.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Telegram");
	}
}
async function cr(e, t) {
	let n = W();
	try {
		let r = await n.post("api/v1/oauth/telegram/oidc/callback", { json: {
			code: e,
			state: t
		} }).json();
		if (!r.success || !r.data) throw new X(r.error?.message || "Telegram OIDC callback failed", r.error?.code || "TELEGRAM_OIDC_CALLBACK_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return $(e, "Telegram");
	}
}
async function $(e, t) {
	let { HTTPError: n } = await import("ky");
	if (e instanceof n) try {
		let n = await e.response.json();
		throw new X(n.error?.message || e.message, n.error?.code || `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status, n.error?.details);
	} catch (n) {
		throw n instanceof X ? n : new X(e.message, `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status);
	}
	throw e instanceof Error ? new X(e.message, "NETWORK_ERROR", 0) : new X("Unknown error", "UNKNOWN_ERROR", 0);
}
//#endregion
//#region src/hooks/useAuth.ts
function lr() {
	let e = Y((e) => e.user), t = Y((e) => e.token), n = Y((e) => e.refreshToken), r = Y((e) => e.isAuthenticated), i = Y((e) => e.isLoading), a = Y((e) => e.login), o = Y((e) => e.logout), c = Y((e) => e.updateUser), l = Y((e) => e.setLoading), u = Y((e) => e.hasRole), d = Y((e) => e.hasAnyRole), f = Y((e) => e.hasPermission);
	return {
		user: e,
		token: t,
		isAuthenticated: r,
		isLoading: i,
		loginWithCredentials: s(async (e) => {
			l(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await yn(e), o = await Tn(t), s = G({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw l(!1), e;
			}
		}, [a, l]),
		loginByCode: s(async (e, t) => {
			l(!0);
			try {
				let { accessToken: n, refreshToken: r, expiresIn: i, user: o } = await wn(e, t), s = await Tn(n), c = G({
					...s,
					user_guid: s.user_guid || o.guid,
					email: s.email || o.email
				});
				return a(n, r, i, c), c;
			} catch (e) {
				throw l(!1), e;
			}
		}, [a, l]),
		registerUser: s(async (e) => {
			l(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await bn(e), o = await Tn(t), s = G({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw l(!1), e;
			}
		}, [a, l]),
		refreshToken: s(async () => {
			await Q();
		}, []),
		logout: s(async () => {
			n && Sn(n), o(), hn();
		}, [n, o]),
		fetchProfile: s(async (e) => {
			if (!t) throw new X("Not authenticated", "NOT_AUTHENTICATED", 401);
			let n = e?.silent ?? !1;
			n || l(!0);
			try {
				let e = G(await Tn(t));
				return c(e), n || l(!1), e;
			} catch (e) {
				throw n || l(!1), e;
			}
		}, [
			t,
			l,
			c
		]),
		hasRole: u,
		hasAnyRole: d,
		hasPermission: f
	};
}
//#endregion
//#region src/hooks/useHasHydrated.ts
function ur() {
	let [e, t] = f(() => Y.persist?.hasHydrated?.() ?? !1);
	return l(() => {
		if (e) return;
		let n = Y.persist?.onFinishHydration?.(() => {
			t(!0);
		});
		return Y.persist?.hasHydrated?.() && t(!0), () => {
			n?.();
		};
	}, [e]), e;
}
//#endregion
//#region src/hooks/useAuthGuard.ts
function dr(e = {}) {
	let { requiredRoles: t = [], requiredPermissions: n = [], requireAllRoles: r = !1 } = e, i = ur(), a = Y((e) => e.user), o = Y((e) => e.isAuthenticated), s = Y((e) => e.hasRole), c = Y((e) => e.hasPermission), l = Y((e) => _n(e)), d = !i || l;
	return {
		...u(() => {
			if (!o || !a || l) return {
				isAllowed: !1,
				isAuthenticated: !1,
				missingRoles: t,
				missingPermissions: n,
				denyReason: "not_authenticated"
			};
			let e = [], i = !0;
			t.length > 0 && (r ? (e = t.filter((e) => !s(e)), i = e.length === 0) : t.some((e) => s(e)) || (e = t, i = !1));
			let u = n.filter((e) => !c(e)), d = u.length === 0;
			return i ? d ? {
				isAllowed: !0,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: [],
				denyReason: "none"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: u,
				denyReason: "missing_permissions"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: e,
				missingPermissions: u,
				denyReason: "missing_roles"
			};
		}, [
			o,
			l,
			a,
			t,
			n,
			r,
			s,
			c
		]),
		isLoading: d,
		user: a
	};
}
//#endregion
//#region src/hooks/useTokenRefresh.ts
var fr = 300 * 1e3, pr = 3, mr = 1e3;
function hr(e) {
	return e.status === 0 || e.status === 429 || e.status >= 500;
}
function gr(e = {}) {
	let { refreshThreshold: t = fr, maxRetries: n = pr, retryBaseDelay: r = mr, onRefreshError: i, onSessionExpired: a } = e, [o, c] = f(!1), [u, p] = f(null), [m, h] = f(0), [g, _] = f(null), v = d(null), y = d(null), b = d(!0), x = d(null), S = Y((e) => e.expiresAt), C = Y((e) => e.isAuthenticated), w = s(() => {
		v.current &&= (clearTimeout(v.current), null);
	}, []), T = s(() => {
		y.current &&= (clearInterval(y.current), null);
	}, []), E = s(() => {
		if (x.current) return x.current;
		let e = (async () => {
			for (let e = 0;; e++) {
				b.current && (c(!0), h(e));
				try {
					await Q(a), b.current && (p(/* @__PURE__ */ new Date()), h(0));
					return;
				} catch (t) {
					let a = t instanceof X ? t : new X(t instanceof Error ? t.message : "Unknown error", "REFRESH_ERROR", 0);
					if (a.status === 401) throw a;
					if (hr(a) && e < n) {
						await new Promise((t) => setTimeout(t, r * 2 ** e));
						continue;
					}
					throw i?.(a), a;
				}
			}
		})().finally(() => {
			x.current = null, b.current && c(!1);
		});
		return x.current = e, e;
	}, [
		n,
		r,
		i,
		a
	]), D = s(() => {
		if (w(), !S || !C) return;
		let e = Date.now(), n = S - t - e;
		n <= 0 ? E().catch(() => {}) : v.current = setTimeout(() => {
			document.visibilityState === "visible" && E().catch(() => {});
		}, n);
	}, [
		S,
		C,
		t,
		w,
		E
	]), O = s(() => {
		document.visibilityState === "visible" ? S && C && (S - Date.now() <= t ? E().catch(() => {}) : D()) : w();
	}, [
		S,
		C,
		t,
		E,
		D,
		w
	]), ee = s(async () => E(), [E]);
	return l(() => {
		if (T(), !S || !C) {
			_(null);
			return;
		}
		let e = () => {
			let e = S - Date.now();
			_(e > 0 ? e : 0);
		};
		return e(), y.current = setInterval(e, 1e3), () => {
			T();
		};
	}, [
		S,
		C,
		T
	]), l(() => {
		D();
	}, [D]), l(() => (document.addEventListener("visibilitychange", O), () => {
		document.removeEventListener("visibilitychange", O);
	}), [O]), l(() => (b.current = !0, () => {
		b.current = !1, w(), T();
	}), [w, T]), {
		isRefreshing: o,
		lastRefresh: u,
		refresh: ee,
		timeUntilExpiry: g,
		retryCount: m
	};
}
//#endregion
//#region src/hooks/useFacebookAuth.ts
function _r(e) {
	let { appId: t, onSuccess: n, onError: r } = e, i = Y((e) => e.login), a = Y((e) => e.setLoading), [o, c] = f(!1), [u, p] = f(!1), [m, h] = f(null), g = d(!1);
	l(() => {
		if (window.FB) {
			p(!0);
			return;
		}
		if (g.current) return;
		if (document.getElementById("facebook-jssdk")) {
			g.current = !0;
			return;
		}
		g.current = !0, window.fbAsyncInit = () => {
			window.FB?.init({
				appId: t,
				version: "v18.0",
				cookie: !0,
				xfbml: !1
			}), p(!0);
		};
		let e = document.createElement("script");
		e.id = "facebook-jssdk", e.src = "https://connect.facebook.net/en_US/sdk.js", e.async = !0, e.defer = !0, document.body.appendChild(e);
	}, [t]);
	let _ = s(async (e) => {
		if (e.status !== "connected" || !e.authResponse) {
			let t = /* @__PURE__ */ Error(e.status === "not_authorized" ? "Facebook login not authorized. Please grant permissions." : "Facebook login was cancelled or failed");
			h(t), c(!1), a(!1), r?.(t);
			return;
		}
		try {
			let t = await ar({ accessToken: e.authResponse.accessToken }), r = await Tn(t.accessToken), a = G({
				...r,
				user_guid: r.user_guid || t.user.guid,
				email: r.email || t.user.email || void 0
			});
			i(t.accessToken, t.refreshToken, t.expiresIn, a), n?.(t, a);
		} catch (e) {
			let t = e instanceof Error ? e : /* @__PURE__ */ Error("Facebook authentication failed");
			h(t), a(!1), r?.(t);
		} finally {
			c(!1);
		}
	}, [
		i,
		a,
		n,
		r
	]);
	return {
		login: s(() => {
			if (!u || !window.FB) {
				let e = /* @__PURE__ */ Error("Facebook SDK not ready. Please try again.");
				h(e), r?.(e);
				return;
			}
			c(!0), a(!0), h(null), window.FB.getLoginStatus((e) => {
				e.status === "connected" && e.authResponse ? _(e) : window.FB.login((e) => {
					_(e);
				}, { scope: "email,public_profile" });
			});
		}, [
			u,
			_,
			a,
			r
		]),
		isLoading: o,
		isReady: u,
		error: m
	};
}
//#endregion
//#region ../node_modules/zod/v4/core/core.js
var vr;
function yr(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var br = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
};
(vr = globalThis).__zod_globalConfig ?? (vr.__zod_globalConfig = {});
var xr = globalThis.__zod_globalConfig;
function Sr(e) {
	return e && Object.assign(xr, e), xr;
}
//#endregion
//#region ../node_modules/zod/v4/core/util.js
function Cr(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
var wr = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
-Number.MAX_VALUE, Number.MAX_VALUE;
function Tr(e) {
	return typeof e == "string" ? e : e?.message;
}
function Er(e, t, n) {
	let r = e.message ? e.message : Tr(e.inst?._zod.def?.error?.(e)) ?? Tr(t?.error?.(e)) ?? Tr(n.customError?.(e)) ?? Tr(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
//#endregion
//#region ../node_modules/zod/v4/core/errors.js
var Dr = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, Cr, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, Or = yr("$ZodError", Dr), kr = /* @__PURE__*/ ((e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new br();
	if (o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => Er(e, a, Sr())));
		throw wr(t, i?.callee), t;
	}
	return o.value;
})(yr("$ZodError", Dr, { Parent: Error }));
//#endregion
//#region ../node_modules/mantine-form-zod-resolver/dist/esm/index.mjs
function Ar(e, t) {
	return (n) => {
		try {
			return kr(e, n), {};
		} catch (e) {
			if (e instanceof Or) {
				let n = {};
				return t?.errorPriority === "first" && e.issues.reverse(), e.issues.forEach((e) => {
					n[e.path.join(".")] = e.message;
				}), n;
			}
			throw e;
		}
	};
}
//#endregion
//#region src/utils/describeOAuthError.ts
function jr(e, t) {
	if (e instanceof X) switch (e.status) {
		case 401: return t("oauth.errors.session_expired");
		case 422: return t("oauth.errors.malformed_link");
		case 429: return t("oauth.errors.rate_limited");
		case 503: return t("oauth.errors.service_unavailable");
		case 0: return t("oauth.errors.network");
		default: return e.message || t("oauth.errors.generic");
	}
	return e instanceof Error ? e.message : t("oauth.errors.generic");
}
//#endregion
//#region src/components/GoogleLoginButton/GoogleLoginButton.tsx
function Mr(e) {
	if (e) return e.startsWith("/") && !e.startsWith("//") ? e : void 0;
}
function Nr({ returnUrl: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = L("auth"), [o, c] = f(!1), [l, u] = f(null), d = s(async () => {
		c(!0), u(null);
		try {
			let { authorizationUrl: t } = await nr(Mr(e));
			window.location.assign(t);
		} catch (e) {
			c(!1), u(jr(e, a)), t?.(e instanceof Error ? e : Error(a("oauth.errors.generic")));
		}
	}, [
		e,
		t,
		a
	]), p = n ?? a("oauth.google.button", "Sign in with Google");
	return /* @__PURE__ */ B(R, { children: [/* @__PURE__ */ z(_, {
		leftSection: r ? void 0 : /* @__PURE__ */ z(oe, { size: 18 }),
		onClick: d,
		loading: o,
		variant: "default",
		...i,
		"aria-label": p,
		"data-testid": "google-login-button",
		children: r ? /* @__PURE__ */ z(oe, { size: 18 }) : p
	}), l && /* @__PURE__ */ z(A, {
		size: "xs",
		c: "red",
		"data-testid": "google-login-error",
		children: l
	})] });
}
//#endregion
//#region src/components/FacebookLoginButton/FacebookLoginButton.tsx
function Pr({ appId: e, onSuccess: t, onError: n, label: r, iconOnly: i = !1, ...a }) {
	let { t: o } = L("auth"), { login: s, isLoading: c, isReady: l } = _r({
		appId: e,
		onSuccess: t,
		onError: n
	}), u = r ?? o("oauth.facebook.button", "Sign in with Facebook");
	return i ? /* @__PURE__ */ z(_, {
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: /* @__PURE__ */ z(ae, { size: 18 })
	}) : /* @__PURE__ */ z(_, {
		leftSection: /* @__PURE__ */ z(ae, { size: 18 }),
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: u
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramIcon.tsx
function Fr({ size: e = 18, ...t }) {
	return /* @__PURE__ */ z("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: e,
		height: e,
		viewBox: "84 154 760 760",
		fill: "currentColor",
		"aria-hidden": "true",
		focusable: "false",
		"data-testid": "telegram-icon",
		...t,
		children: /* @__PURE__ */ z("path", { d: "M226.328419,494.722069 C372.088573,431.216685 469.284839,389.350049 517.917216,369.122161 C656.772535,311.36743 685.625481,301.334815 704.431427,301.003532 C708.567621,300.93067 717.815839,301.955743 723.806446,306.816707 C728.864797,310.92121 730.256552,316.46581 730.922551,320.357329 C731.588551,324.248848 732.417879,333.113828 731.758626,340.040666 C724.234007,419.102486 691.675104,610.964674 675.110982,699.515267 C668.10208,736.984342 654.301336,749.547532 640.940618,750.777006 C611.904684,753.448938 589.856115,731.588035 561.733393,713.153237 C517.726886,684.306416 492.866009,666.349181 450.150074,638.200013 C400.78442,605.66878 432.786119,587.789048 460.919462,558.568563 C468.282091,550.921423 596.21508,434.556479 598.691227,424.000355 C599.00091,422.680135 599.288312,417.758981 596.36474,415.160431 C593.441168,412.561881 589.126229,413.450484 586.012448,414.157198 C581.598758,415.158943 511.297793,461.625274 375.109553,553.556189 C355.154858,567.258623 337.080515,573.934908 320.886524,573.585046 C303.033948,573.199351 268.692754,563.490928 243.163606,555.192408 C211.851067,545.013936 186.964484,539.632504 189.131547,522.346309 C190.260287,513.342589 202.659244,504.134509 226.328419,494.722069 Z" })
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramLoginButton.tsx
function Ir(e) {
	if (e) return e.startsWith("/") && !e.startsWith("//") ? e : void 0;
}
function Lr({ returnUrl: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = L("auth"), [o, c] = f(!1), [l, u] = f(null), d = s(async () => {
		c(!0), u(null);
		try {
			let { authorizationUrl: t } = await or(Ir(e));
			window.location.assign(t);
		} catch (e) {
			c(!1), u(jr(e, a)), t?.(e instanceof Error ? e : Error(a("oauth.errors.generic")));
		}
	}, [
		e,
		t,
		a
	]), p = n ?? a("oauth.telegram.button", "Log in with Telegram");
	return /* @__PURE__ */ B(R, { children: [/* @__PURE__ */ z(_, {
		leftSection: r ? void 0 : /* @__PURE__ */ z(Fr, { size: 18 }),
		onClick: d,
		loading: o,
		variant: "default",
		...i,
		"aria-label": p,
		"data-testid": "telegram-login-button",
		children: r ? /* @__PURE__ */ z(Fr, { size: 18 }) : p
	}), l && /* @__PURE__ */ z(A, {
		size: "xs",
		c: "red",
		"data-testid": "telegram-login-error",
		children: l
	})] });
}
//#endregion
//#region src/components/SocialLoginButtons/SocialLoginButtons.tsx
function Rr({ google: e = !0, facebook: t = !0, telegram: n = !0, facebookAppId: r, returnUrl: i, onSuccess: a, onError: o, showDivider: s = !0, dividerText: c, layout: l = "vertical", ...u }) {
	let { t: d } = L("auth");
	t && !r && console.warn("SocialLoginButtons: facebookAppId is required when facebook=true");
	let f = (e) => (t, n) => {
		a?.(t, n, e);
	}, p = (e) => (t) => {
		o?.(t, e);
	};
	if ([
		e,
		t && r,
		n
	].filter(Boolean).length === 0) return null;
	let m = /* @__PURE__ */ B(R, { children: [
		e && /* @__PURE__ */ z(Nr, {
			returnUrl: i,
			onError: p("google"),
			fullWidth: l === "vertical"
		}),
		t && r && /* @__PURE__ */ z(Pr, {
			appId: r,
			onSuccess: f("facebook"),
			onError: p("facebook"),
			fullWidth: l === "vertical"
		}),
		n && /* @__PURE__ */ z(Lr, {
			returnUrl: i,
			onError: p("telegram"),
			fullWidth: l === "vertical"
		})
	] });
	return /* @__PURE__ */ B(k, {
		gap: "sm",
		...u,
		"data-testid": "social-login-buttons",
		children: [s && /* @__PURE__ */ z(x, {
			label: /* @__PURE__ */ z(A, {
				size: "sm",
				c: "dimmed",
				children: c || d("oauth.divider", "or")
			}),
			labelPosition: "center"
		}), l === "vertical" ? /* @__PURE__ */ z(k, {
			gap: "xs",
			children: m
		}) : /* @__PURE__ */ z(S, {
			gap: "xs",
			justify: "center",
			children: m
		})]
	});
}
//#endregion
//#region src/components/LoginForm/LoginForm.tsx
var zr = I.object({
	email: I.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	password: I.string().min(1, "login.errors.password_required")
}), Br = I.object({
	email: I.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	code: I.string().min(6, "login.errors.code_invalid").max(6, "login.errors.code_invalid")
});
function Vr({ onSuccess: e, onError: t, disabled: n = !1, showSocialLogin: r = !0, facebookAppId: i, returnUrl: a, onSocialSuccess: o, onSocialError: c, showCodeLogin: u = !0, defaultMethod: d = "password" }) {
	let { t: h } = L("auth"), { loginWithCredentials: g, loginByCode: v, isLoading: y } = lr(), [b, S] = f(null), [C, w] = f(d), [T, E] = f(!1), [O, M] = f(!1), N = re({
		initialValues: {
			email: "",
			password: ""
		},
		validate: Ar(zr)
	}), P = re({
		initialValues: {
			email: "",
			code: ""
		},
		validate: Ar(Br)
	});
	l(() => {
		C === "code" ? P.setFieldValue("email", N.values.email) : N.setFieldValue("email", P.values.email), S(null);
	}, [C]);
	let te = s(async (n) => {
		S(null);
		try {
			let t = await g({
				email: n.email,
				password: n.password
			});
			e?.(t);
		} catch (e) {
			let n = Hr(e, h);
			S(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		g,
		e,
		t,
		h
	]), ne = s(async () => {
		if (!P.validateField("email").hasError) {
			S(null), M(!0);
			try {
				await Cn(P.values.email), E(!0);
			} catch (e) {
				S(Ur(e, h));
			} finally {
				M(!1);
			}
		}
	}, [P, h]), ie = s(async (n) => {
		S(null);
		try {
			let t = await v(n.email, n.code);
			e?.(t);
		} catch (e) {
			let n = Ur(e, h);
			S(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		v,
		e,
		t,
		h
	]), ae = s(() => {
		E(!1), P.setFieldValue("code", ""), S(null);
	}, [P]), oe = s((t, n, r) => {
		e?.(n), o?.(t, r);
	}, [e, o]), se = y || n;
	return /* @__PURE__ */ B(k, {
		gap: "md",
		children: [
			r && /* @__PURE__ */ B(R, { children: [/* @__PURE__ */ z(Rr, {
				facebookAppId: i,
				returnUrl: a,
				onSuccess: oe,
				onError: c,
				showDivider: !1
			}), /* @__PURE__ */ z(x, {
				label: /* @__PURE__ */ z(A, {
					size: "sm",
					c: "dimmed",
					children: h("login.or_with_email")
				}),
				labelPosition: "center"
			})] }),
			b && /* @__PURE__ */ z(p, {
				icon: /* @__PURE__ */ z(F, { size: 16 }),
				color: "red",
				variant: "light",
				title: h("login.error_title"),
				"aria-live": "polite",
				"data-testid": "login-error",
				children: b
			}),
			u && /* @__PURE__ */ z(ee, {
				value: C,
				onChange: (e) => w(e),
				data: [{
					label: h("login.method_password"),
					value: "password"
				}, {
					label: h("login.method_code"),
					value: "code"
				}],
				fullWidth: !0,
				"data-testid": "login-method-toggle"
			}),
			C === "password" && /* @__PURE__ */ z("form", {
				onSubmit: N.onSubmit(te),
				noValidate: !0,
				children: /* @__PURE__ */ B(k, {
					gap: "md",
					children: [
						/* @__PURE__ */ z(j, {
							label: h("login.email_label"),
							placeholder: h("login.email_placeholder"),
							leftSection: /* @__PURE__ */ z(me, { size: 16 }),
							autoComplete: "email",
							type: "email",
							inputMode: "email",
							"data-autofocus": !0,
							"data-testid": "login-email",
							"aria-label": h("login.email_label"),
							"aria-required": "true",
							"aria-invalid": !!N.errors.email,
							disabled: se,
							...N.getInputProps("email"),
							error: N.errors.email ? h(N.errors.email) : void 0
						}),
						/* @__PURE__ */ z(D, {
							label: h("login.password_label"),
							placeholder: h("login.password_placeholder"),
							leftSection: /* @__PURE__ */ z(fe, { size: 16 }),
							autoComplete: "current-password",
							"data-testid": "login-password",
							"aria-label": h("login.password_label"),
							"aria-required": "true",
							"aria-invalid": !!N.errors.password,
							disabled: se,
							...N.getInputProps("password"),
							error: N.errors.password ? h(N.errors.password) : void 0
						}),
						/* @__PURE__ */ z(_, {
							type: "submit",
							fullWidth: !0,
							loading: y,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: h("login.submit")
						})
					]
				})
			}),
			C === "code" && /* @__PURE__ */ z("form", {
				onSubmit: P.onSubmit(ie),
				noValidate: !0,
				children: /* @__PURE__ */ B(k, {
					gap: "md",
					children: [/* @__PURE__ */ z(j, {
						label: h("login.email_label"),
						placeholder: h("login.email_placeholder"),
						leftSection: /* @__PURE__ */ z(me, { size: 16 }),
						autoComplete: "email",
						type: "email",
						inputMode: "email",
						"data-autofocus": !0,
						"data-testid": "login-email",
						"aria-label": h("login.email_label"),
						"aria-required": "true",
						"aria-invalid": !!P.errors.email,
						disabled: se || T,
						...P.getInputProps("email"),
						error: P.errors.email ? h(P.errors.email) : void 0
					}), T ? /* @__PURE__ */ B(R, { children: [
						/* @__PURE__ */ z(A, {
							size: "sm",
							c: "teal",
							"data-testid": "login-code-sent-msg",
							children: h("login.code_sent")
						}),
						/* @__PURE__ */ z(j, {
							label: h("login.code"),
							placeholder: "000000",
							leftSection: /* @__PURE__ */ z(he, { size: 16 }),
							autoComplete: "one-time-code",
							inputMode: "numeric",
							maxLength: 6,
							"data-testid": "login-code",
							"aria-label": h("login.code"),
							"aria-required": "true",
							"aria-invalid": !!P.errors.code,
							disabled: se,
							...P.getInputProps("code"),
							error: P.errors.code ? h(P.errors.code) : void 0
						}),
						/* @__PURE__ */ z(_, {
							type: "submit",
							fullWidth: !0,
							loading: y,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: h("login.verify_and_sign_in")
						}),
						/* @__PURE__ */ z(m, {
							component: "button",
							type: "button",
							size: "sm",
							ta: "center",
							onClick: ae,
							"data-testid": "login-resend-code",
							children: h("login.resend_code")
						})
					] }) : /* @__PURE__ */ z(_, {
						fullWidth: !0,
						variant: "light",
						loading: O,
						disabled: n,
						onClick: ne,
						"data-testid": "login-send-code",
						mt: "xs",
						children: h("login.send_code")
					})]
				})
			})
		]
	});
}
function Hr(e, t) {
	if (e instanceof X) switch (e.code) {
		case "INVALID_CREDENTIALS": return t("login.errors.invalid_credentials");
		case "ACCOUNT_LOCKED": return t("login.errors.account_locked");
		case "ACCOUNT_DISABLED": return t("login.errors.account_disabled");
		case "EMAIL_NOT_VERIFIED": return t("login.errors.email_not_verified");
		default: return e.message || t("login.errors.generic");
	}
	return e instanceof Error && e.message || t("login.errors.generic");
}
function Ur(e, t) {
	if (e instanceof X) switch (e.code) {
		case "CODE_EXPIRED": return t("login.errors.code_expired");
		case "RATE_LIMITED": return t("login.errors.code_rate_limited");
		case "INVALID_CODE": {
			let n = e.details?.remaining;
			return n === void 0 ? t("login.errors.code_invalid_value", { remaining: "?" }) : t("login.errors.code_invalid_value", { remaining: n });
		}
		default: return e.message || t("login.errors.code_send_failed");
	}
	return e instanceof Error && e.message || t("login.errors.code_send_failed");
}
//#endregion
//#region src/components/LoginModal/LoginModal.tsx
function Wr({ opened: e, onClose: t, onSuccess: n, onError: r, title: i, subtitle: a, closeOnSuccess: o = !0, size: c = "sm", centered: l = !0, showSocialLogin: u = !1, showCodeLogin: d, defaultMethod: f, facebookAppId: p, returnUrl: m }) {
	let { t: h } = L("auth"), g = s((e) => {
		n?.(e), o && t();
	}, [
		n,
		t,
		o
	]);
	return /* @__PURE__ */ z(T, {
		opened: e,
		onClose: t,
		title: i || h("login.modal_title"),
		size: c,
		centered: l,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !0,
		"aria-labelledby": "login-modal-title",
		"data-testid": "login-modal",
		children: /* @__PURE__ */ B(k, {
			gap: "md",
			children: [a && /* @__PURE__ */ z(A, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: a
			}), /* @__PURE__ */ z(Vr, {
				onSuccess: g,
				onError: r,
				showSocialLogin: u,
				showCodeLogin: d,
				defaultMethod: f,
				facebookAppId: p,
				returnUrl: m
			})]
		})
	});
}
//#endregion
//#region src/components/LoginPage/LoginPage.tsx
function Gr({ onSuccess: e, onError: t, redirectOnSuccess: n, logo: r, backgroundImage: i, title: a, subtitle: o, maxWidth: c = 420, showSocialLogin: l = !1, showCodeLogin: u, defaultMethod: d, facebookAppId: f, returnUrl: p }) {
	let { t: m } = L("auth"), h = ne(), _ = te("light") === "dark", y = s((t) => {
		e?.(t), n && typeof window < "u" && (window.location.href = n);
	}, [e, n]);
	return /* @__PURE__ */ z(v, {
		mih: "100vh",
		style: {
			...i ? {
				backgroundImage: `url(${i})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat"
			} : {},
			backgroundColor: i ? void 0 : _ ? h.colors.dark[8] : h.colors.gray[0]
		},
		"data-testid": "login-page",
		children: /* @__PURE__ */ z(g, {
			w: {
				base: "100%",
				sm: c
			},
			px: "md",
			py: "xl",
			children: /* @__PURE__ */ B(k, {
				gap: "lg",
				align: "center",
				children: [
					r && /* @__PURE__ */ z(g, {
						mb: "md",
						"data-testid": "login-page-logo",
						children: r
					}),
					/* @__PURE__ */ z(E, {
						p: "xl",
						shadow: "md",
						radius: "md",
						withBorder: !0,
						w: "100%",
						style: i ? {
							backgroundColor: "rgba(255, 255, 255, 0.95)",
							backdropFilter: "blur(10px)"
						} : void 0,
						children: /* @__PURE__ */ B(k, {
							gap: "md",
							children: [
								/* @__PURE__ */ z(N, {
									order: 2,
									ta: "center",
									"data-testid": "login-page-title",
									children: a || m("login.page_title")
								}),
								(o || !a) && /* @__PURE__ */ z(A, {
									size: "sm",
									c: "dimmed",
									ta: "center",
									children: o || m("login.page_subtitle")
								}),
								/* @__PURE__ */ z(Vr, {
									onSuccess: y,
									onError: t,
									showSocialLogin: l,
									showCodeLogin: u,
									defaultMethod: d,
									facebookAppId: f,
									returnUrl: p
								})
							]
						})
					}),
					/* @__PURE__ */ z(A, {
						size: "xs",
						c: "dimmed",
						ta: "center",
						children: m("login.help_text")
					})
				]
			})
		})
	});
}
//#endregion
//#region src/components/RegisterForm/PasswordStrengthIndicator.tsx
function Kr(e) {
	return [
		{
			key: "length",
			label: "password.requirements.length",
			met: e.length >= 8
		},
		{
			key: "uppercase",
			label: "password.requirements.uppercase",
			met: /[A-Z]/.test(e)
		},
		{
			key: "lowercase",
			label: "password.requirements.lowercase",
			met: /[a-z]/.test(e)
		},
		{
			key: "number",
			label: "password.requirements.number",
			met: /[0-9]/.test(e)
		}
	];
}
function qr(e) {
	if (!e) return 0;
	let t = Kr(e), n = t.filter((e) => e.met).length / t.length * 80, r = /[!@#$%^&*(),.?":{}|<>]/.test(e) ? 10 : 0, i = Math.min(10, Math.max(0, e.length - 8));
	return Math.min(100, n + r + i);
}
function Jr(e) {
	return e < 30 ? "red" : e < 60 ? "yellow" : e < 80 ? "lime" : "green";
}
function Yr(e) {
	return e < 30 ? "password.strength.weak" : e < 60 ? "password.strength.fair" : e < 80 ? "password.strength.good" : "password.strength.strong";
}
function Xr({ met: e, label: t }) {
	let { t: n } = L("auth");
	return /* @__PURE__ */ B(S, {
		gap: "xs",
		wrap: "nowrap",
		children: [/* @__PURE__ */ z(M, {
			size: "xs",
			radius: "xl",
			color: e ? "green" : "red",
			variant: "light",
			children: z(e ? ce : ye, { size: 10 })
		}), /* @__PURE__ */ z(A, {
			size: "xs",
			c: e ? "dimmed" : void 0,
			style: { textDecoration: e ? "line-through" : void 0 },
			children: n(t)
		})]
	});
}
function Zr({ password: e, showRequirements: t = !0, compact: n = !1 }) {
	let { t: r } = L("auth"), i = u(() => qr(e), [e]), a = u(() => Kr(e), [e]), o = Jr(i), s = Yr(i);
	return e ? n ? /* @__PURE__ */ z(O, {
		value: i,
		color: o,
		size: "xs",
		"aria-label": r("password.strength.label"),
		"aria-valuenow": i,
		"aria-valuemin": 0,
		"aria-valuemax": 100
	}) : /* @__PURE__ */ B(k, {
		gap: "xs",
		"data-testid": "password-strength-indicator",
		children: [
			/* @__PURE__ */ B(S, {
				justify: "space-between",
				gap: "xs",
				children: [/* @__PURE__ */ z(A, {
					size: "xs",
					c: "dimmed",
					children: r("password.strength.label")
				}), /* @__PURE__ */ z(A, {
					size: "xs",
					c: o,
					fw: 500,
					children: r(s)
				})]
			}),
			/* @__PURE__ */ z(O, {
				value: i,
				color: o,
				size: "sm",
				"aria-label": r("password.strength.label"),
				"aria-valuenow": i,
				"aria-valuemin": 0,
				"aria-valuemax": 100,
				"data-testid": "password-strength-progress"
			}),
			t && /* @__PURE__ */ z(g, {
				mt: "xs",
				children: /* @__PURE__ */ z(k, {
					gap: 4,
					children: a.map((e) => /* @__PURE__ */ z(Xr, {
						met: e.met,
						label: e.label
					}, e.key))
				})
			})
		]
	}) : null;
}
//#endregion
//#region src/components/RegisterForm/RegisterForm.tsx
var Qr = I.object({
	name: I.string().min(1, "register.errors.name_required").max(100, "register.errors.name_too_long"),
	email: I.string().min(1, "register.errors.email_required").email("register.errors.email_invalid"),
	password: I.string().min(8, "register.errors.password_min_length").refine((e) => /[A-Z]/.test(e), "register.errors.password_uppercase").refine((e) => /[a-z]/.test(e), "register.errors.password_lowercase").refine((e) => /[0-9]/.test(e), "register.errors.password_number"),
	confirmPassword: I.string().min(1, "register.errors.confirm_password_required"),
	acceptTerms: I.boolean().refine((e) => e === !0, "register.errors.terms_required")
}).refine((e) => e.password === e.confirmPassword, {
	message: "register.errors.passwords_mismatch",
	path: ["confirmPassword"]
});
function $r({ onSuccess: e, onError: t, showLogin: n = !1, onLoginClick: r, termsUrl: i = "/terms", privacyUrl: a = "/privacy", submitLabel: o, disabled: c = !1, showPasswordStrength: l = !0, showSocialLogin: u = !1, facebookAppId: d, returnUrl: h, onSocialSuccess: g, onSocialError: v }) {
	let { t: b } = L("auth"), [C, w] = f(!1), [T, E] = f(null), O = re({
		initialValues: {
			name: "",
			email: "",
			password: "",
			confirmPassword: "",
			acceptTerms: !1
		},
		validate: Ar(Qr)
	}), ee = s((e) => Kr(e).every((e) => e.met), []), M = s(async (n) => {
		E(null), w(!0);
		try {
			await bn({
				email: n.email,
				password: n.password,
				firstName: n.name.split(" ")[0],
				lastName: n.name.split(" ").slice(1).join(" ") || void 0
			}), e?.();
		} catch (e) {
			let n;
			if (e instanceof X) switch (e.code) {
				case "EMAIL_EXISTS":
				case "USER_EXISTS":
					n = b("register.errors.email_exists");
					break;
				case "VALIDATION_ERROR":
					n = b("register.errors.validation_error");
					break;
				case "RATE_LIMITED":
					n = b("register.errors.rate_limited");
					break;
				default: n = e.message || b("register.errors.generic");
			}
			else n = e instanceof Error && e.message || b("register.errors.generic");
			E(n), t?.(e instanceof Error ? e : Error(n));
		} finally {
			w(!1);
		}
	}, [
		e,
		t,
		b
	]), N = C || c, P = O.values.password && !ee(O.values.password), te = s((t, n, r) => {
		e?.(n), g?.(t, r);
	}, [e, g]);
	return /* @__PURE__ */ z("form", {
		onSubmit: O.onSubmit(M),
		noValidate: !0,
		children: /* @__PURE__ */ B(k, {
			gap: "md",
			children: [
				u && /* @__PURE__ */ B(R, { children: [/* @__PURE__ */ z(Rr, {
					facebookAppId: d,
					returnUrl: h,
					onSuccess: te,
					onError: v,
					showDivider: !1
				}), /* @__PURE__ */ z(x, {
					label: /* @__PURE__ */ z(A, {
						size: "sm",
						c: "dimmed",
						children: b("register.or_email", "or with email")
					}),
					labelPosition: "center"
				})] }),
				T && /* @__PURE__ */ z(p, {
					icon: /* @__PURE__ */ z(F, { size: 16 }),
					color: "red",
					variant: "light",
					title: b("register.error_title"),
					"aria-live": "polite",
					"data-testid": "register-error",
					children: T
				}),
				/* @__PURE__ */ z(j, {
					label: b("register.name_label"),
					placeholder: b("register.name_placeholder"),
					leftSection: /* @__PURE__ */ z(_e, { size: 16 }),
					autoComplete: "name",
					"data-autofocus": !0,
					"data-testid": "register-name",
					"aria-label": b("register.name_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.name,
					disabled: N,
					...O.getInputProps("name"),
					error: O.errors.name ? b(O.errors.name) : void 0
				}),
				/* @__PURE__ */ z(j, {
					label: b("register.email_label"),
					placeholder: b("register.email_placeholder"),
					leftSection: /* @__PURE__ */ z(me, { size: 16 }),
					autoComplete: "email",
					type: "email",
					inputMode: "email",
					"data-testid": "register-email",
					"aria-label": b("register.email_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.email,
					disabled: N,
					...O.getInputProps("email"),
					error: O.errors.email ? b(O.errors.email) : void 0
				}),
				/* @__PURE__ */ B(k, {
					gap: "xs",
					children: [/* @__PURE__ */ z(D, {
						label: b("register.password_label"),
						placeholder: b("register.password_placeholder"),
						leftSection: /* @__PURE__ */ z(fe, { size: 16 }),
						autoComplete: "new-password",
						"data-testid": "register-password",
						"aria-label": b("register.password_label"),
						"aria-required": "true",
						"aria-invalid": !!O.errors.password,
						"aria-describedby": "password-requirements",
						disabled: N,
						...O.getInputProps("password"),
						error: O.errors.password ? b(O.errors.password) : void 0
					}), l && /* @__PURE__ */ z("div", {
						id: "password-requirements",
						children: /* @__PURE__ */ z(Zr, {
							password: O.values.password,
							showRequirements: !0
						})
					})]
				}),
				/* @__PURE__ */ z(D, {
					label: b("register.confirm_password_label"),
					placeholder: b("register.confirm_password_placeholder"),
					leftSection: /* @__PURE__ */ z(fe, { size: 16 }),
					autoComplete: "new-password",
					"data-testid": "register-confirm-password",
					"aria-label": b("register.confirm_password_label"),
					"aria-required": "true",
					"aria-invalid": !!O.errors.confirmPassword,
					disabled: N,
					...O.getInputProps("confirmPassword"),
					error: O.errors.confirmPassword ? b(O.errors.confirmPassword) : void 0
				}),
				/* @__PURE__ */ z(y, {
					label: /* @__PURE__ */ B(R, { children: [
						b("register.terms_prefix"),
						" ",
						/* @__PURE__ */ z(m, {
							href: i,
							target: "_blank",
							size: "sm",
							children: b("register.terms_link")
						}),
						" ",
						b("register.terms_and"),
						" ",
						/* @__PURE__ */ z(m, {
							href: a,
							target: "_blank",
							size: "sm",
							children: b("register.privacy_link")
						})
					] }),
					"data-testid": "register-terms",
					"aria-required": "true",
					"aria-invalid": !!O.errors.acceptTerms,
					disabled: N,
					...O.getInputProps("acceptTerms", { type: "checkbox" }),
					error: O.errors.acceptTerms ? b(O.errors.acceptTerms) : void 0
				}),
				/* @__PURE__ */ z(_, {
					type: "submit",
					fullWidth: !0,
					loading: C,
					disabled: c || !!P,
					"data-testid": "register-submit",
					mt: "xs",
					children: o || b("register.submit")
				}),
				n && /* @__PURE__ */ z(S, {
					justify: "center",
					mt: "xs",
					children: /* @__PURE__ */ z(m, {
						component: "button",
						type: "button",
						size: "sm",
						onClick: r,
						"data-testid": "register-login-link",
						children: b("register.have_account")
					})
				})
			]
		})
	});
}
//#endregion
//#region src/components/RegisterModal/VerificationSuccess.tsx
function ei({ email: e, onResendClick: t, onLoginClick: n, title: r, message: i }) {
	let { t: a } = L("auth"), [o, c] = f(!1), [l, u] = f(!1), [d, h] = f(null), g = s(async () => {
		if (t) {
			c(!0), u(!1), h(null);
			try {
				await t(), u(!0);
			} catch (e) {
				h(e instanceof Error ? e.message : a("register.verification.resend_error"));
			} finally {
				c(!1);
			}
		}
	}, [t, a]);
	return /* @__PURE__ */ B(k, {
		gap: "lg",
		align: "center",
		"data-testid": "verification-success",
		children: [
			/* @__PURE__ */ z(v, { children: /* @__PURE__ */ z(M, {
				size: 80,
				radius: 80,
				variant: "light",
				color: "green",
				"aria-hidden": "true",
				children: /* @__PURE__ */ z(me, { size: 40 })
			}) }),
			/* @__PURE__ */ B(k, {
				gap: "xs",
				align: "center",
				children: [/* @__PURE__ */ z(A, {
					size: "xl",
					fw: 600,
					ta: "center",
					children: r || a("register.verification.title")
				}), /* @__PURE__ */ z(A, {
					size: "sm",
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: i || a("register.verification.message", { email: e })
				})]
			}),
			l && /* @__PURE__ */ z(p, {
				icon: /* @__PURE__ */ z(ce, { size: 16 }),
				color: "green",
				variant: "light",
				w: "100%",
				"data-testid": "resend-success",
				children: a("register.verification.resend_success")
			}),
			d && /* @__PURE__ */ z(p, {
				icon: /* @__PURE__ */ z(F, { size: 16 }),
				color: "red",
				variant: "light",
				w: "100%",
				"data-testid": "resend-error",
				children: d
			}),
			/* @__PURE__ */ B(k, {
				gap: "md",
				w: "100%",
				children: [t && /* @__PURE__ */ z(_, {
					variant: "light",
					fullWidth: !0,
					loading: o,
					disabled: l,
					onClick: g,
					"data-testid": "resend-verification",
					children: a(l ? "register.verification.resend_sent" : "register.verification.resend_button")
				}), n && /* @__PURE__ */ z(v, { children: /* @__PURE__ */ z(m, {
					component: "button",
					type: "button",
					size: "sm",
					onClick: n,
					"data-testid": "back-to-login",
					children: a("register.verification.back_to_login")
				}) })]
			})
		]
	});
}
//#endregion
//#region src/components/RegisterModal/RegisterModal.tsx
function ti({ opened: e, onClose: t, onSuccess: n, onError: r, showLogin: i = !1, onLoginClick: a, termsUrl: o, privacyUrl: c, onResendVerification: l, title: u, subtitle: d, size: p = "sm", centered: m = !0, showSocialLogin: h = !1, facebookAppId: g, returnUrl: _ }) {
	let { t: v } = L("auth"), [y, b] = f(!1), [x, S] = f(""), C = s(() => {
		n?.(), b(!0);
	}, [n]), w = s(() => {
		a && a(), t();
	}, [a, t]), E = s(async () => {
		l && x && await l(x);
	}, [l, x]), D = s(() => {
		b(!1), S(""), t();
	}, [t]), O = s(() => {
		C();
	}, [C]);
	return /* @__PURE__ */ z(T, {
		opened: e,
		onClose: D,
		title: y ? v("register.verification.title") : u || v("register.modal_title"),
		size: p,
		centered: m,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !y,
		"aria-labelledby": "register-modal-title",
		"data-testid": "register-modal",
		children: /* @__PURE__ */ B(k, {
			gap: "md",
			children: [!y && d && /* @__PURE__ */ z(A, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: d
			}), y ? /* @__PURE__ */ z(ei, {
				email: x,
				onResendClick: l ? E : void 0,
				onLoginClick: w
			}) : /* @__PURE__ */ z(ni, {
				onSuccess: O,
				onError: r,
				onEmailCapture: S,
				showLogin: i,
				onLoginClick: w,
				termsUrl: o,
				privacyUrl: c,
				showSocialLogin: h,
				facebookAppId: g,
				returnUrl: _
			})]
		})
	});
}
function ni({ onSuccess: e, onError: t, onEmailCapture: n, ...r }) {
	return /* @__PURE__ */ z("div", {
		onSubmitCapture: s((e) => {
			let t = e.currentTarget.querySelector("form");
			if (t) {
				let e = t.querySelector("[data-testid=\"register-email\"]");
				e && n(e.value);
			}
		}, [n]),
		children: /* @__PURE__ */ z($r, {
			onSuccess: e,
			onError: t,
			...r
		})
	});
}
//#endregion
//#region src/components/AuthGuard/UnauthorizedFallback.tsx
function ri({ title: e, message: t, showBackButton: n = !0, showHomeButton: r = !0, homeUrl: i = "/", onBack: a, onHome: o }) {
	let { t: s } = L("auth");
	return /* @__PURE__ */ B(k, {
		align: "center",
		justify: "center",
		gap: "xl",
		mih: 400,
		p: "xl",
		children: [
			/* @__PURE__ */ z(M, {
				size: 80,
				radius: "xl",
				variant: "light",
				color: "red",
				children: /* @__PURE__ */ z(fe, { size: 40 })
			}),
			/* @__PURE__ */ B(k, {
				align: "center",
				gap: "xs",
				children: [/* @__PURE__ */ z(N, {
					order: 2,
					ta: "center",
					children: e || s("guard.unauthorized_title", "Access Denied")
				}), /* @__PURE__ */ z(A, {
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: t || s("guard.unauthorized_message", "You don't have permission to access this page.")
				})]
			}),
			/* @__PURE__ */ B(S, {
				gap: "md",
				children: [n && /* @__PURE__ */ z(_, {
					variant: "default",
					leftSection: /* @__PURE__ */ z(ie, { size: 16 }),
					onClick: () => {
						a ? a() : window.history.back();
					},
					children: s("guard.go_back", "Go Back")
				}), r && /* @__PURE__ */ z(_, {
					variant: "filled",
					leftSection: /* @__PURE__ */ z(ue, { size: 16 }),
					onClick: () => {
						o ? o() : window.location.href = i;
					},
					children: s("guard.go_home", "Go Home")
				})]
			})
		]
	});
}
//#endregion
//#region src/components/AuthGuard/LoadingFallback.tsx
function ii({ message: e, minHeight: t = "100vh", size: n = "lg" }) {
	let { t: r } = L("auth");
	return /* @__PURE__ */ z(v, {
		mih: t,
		children: /* @__PURE__ */ B(k, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ z(C, { size: n }), /* @__PURE__ */ z(A, {
				c: "dimmed",
				size: "sm",
				children: e || r("guard.loading", "Checking authentication...")
			})]
		})
	});
}
//#endregion
//#region src/components/AuthGuard/redirectUtils.ts
var ai = "returnTo", oi = 2e3;
function si(e) {
	if (!e || typeof e != "string" || e.length > oi) return !1;
	try {
		if (e.startsWith("/")) return !e.startsWith("//");
		let t = new URL(e, window.location.origin), n = new URL(window.location.origin);
		if (t.origin !== n.origin) {
			let e = t.hostname;
			if (![".teletienda.ar", ".teletienda.local"].some((t) => e.endsWith(t) || e === t.slice(1))) return !1;
		}
		return !0;
	} catch {
		return !1;
	}
}
function ci(e, t) {
	if (!t || !si(t)) return e;
	try {
		let n = new URL(e, window.location.origin);
		return n.searchParams.set(ai, t), n.origin === window.location.origin ? n.pathname + n.search : n.toString();
	} catch {
		return e;
	}
}
function li() {
	try {
		let e = new URLSearchParams(window.location.search).get(ai);
		return e && si(e) ? e : null;
	} catch {
		return null;
	}
}
function ui() {
	return window.location.pathname + window.location.search;
}
function di(e) {
	let t = si(e) ? e : "/";
	window.location.href = t;
}
function fi(e) {
	try {
		let t = new URL(e, window.location.origin), n = window.location;
		return t.pathname === n.pathname && t.search === n.search;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/components/AuthGuard/AuthGuard.tsx
function pi({ children: e, redirectTo: t, preserveReturnUrl: n = !0, fallback: r, loadingComponent: i, onDenied: a, navigate: o, requiredRoles: s, requiredPermissions: c, requireAllRoles: u }) {
	let { isAllowed: f, isLoading: p, isAuthenticated: m, denyReason: h, missingRoles: g, missingPermissions: _ } = dr({
		requiredRoles: s,
		requiredPermissions: c,
		requireAllRoles: u
	}), v = d(!1);
	return l(() => {
		if (!p) {
			if (f) {
				v.current = !1;
				return;
			}
			if (h !== "none" && a && a(h), h === "not_authenticated" && t) {
				if (v.current) return;
				let e = ci(t, n ? ui() : void 0);
				if (fi(e)) {
					console.warn("[AuthGuard] Redirect loop detected, skipping redirect");
					return;
				}
				v.current = !0, o ? o(e, { replace: !0 }) : di(e);
			}
		}
	}, [
		p,
		f,
		m,
		h,
		t,
		n,
		a,
		o
	]), p ? i || /* @__PURE__ */ z(ii, {}) : f ? /* @__PURE__ */ z(R, { children: e }) : m && h !== "not_authenticated" ? r || /* @__PURE__ */ z(ri, {
		missingRoles: g,
		missingPermissions: _
	}) : t ? i || /* @__PURE__ */ z(ii, {}) : r || /* @__PURE__ */ z(ri, {});
}
//#endregion
//#region src/components/AuthGuard/ProtectedRoute.tsx
function mi({ children: e, element: t, ...n }) {
	let r = t || e;
	return /* @__PURE__ */ z(pi, {
		...n,
		children: r
	});
}
//#endregion
//#region src/components/UserMenu/UserAvatar.tsx
function hi({ src: e, name: t, size: n = "md", radius: r = "xl", className: i }) {
	return /* @__PURE__ */ z(h, {
		src: e,
		name: t,
		alt: t,
		size: n,
		radius: r,
		color: "initials",
		className: i
	});
}
var gi = {
	userButton: "_userButton_1mcpb_5",
	userName: "_userName_1mcpb_28",
	chevron: "_chevron_1mcpb_32"
};
//#endregion
//#region src/components/UserMenu/UserMenu.tsx
function _i({ showProfile: e = !0, showOrders: t = !1, showFinances: n = !1, profileHref: r = "/profile", ordersHref: i = "/orders", financesHref: a = "/finances", additionalItems: o = [], onLogout: c, confirmLogout: l = !1, logoutRedirect: u, avatarSrc: d, hideUserName: p = !1, children: m }) {
	let { t: h } = L("auth"), { user: g, logout: v, isLoading: y } = lr(), [b, x] = f(!1), [C, { open: E, close: D }] = be(!1), [O, ee] = f(!1), j = xe("(max-width: 768px)"), M = p || j, N = s(() => {
		l ? E() : te();
	}, [l, E]), te = s(async () => {
		ee(!0);
		try {
			let e = u || "/";
			window.location.href = e, await v(), Se.show({
				title: h("userMenu.logout_success_title"),
				message: h("userMenu.logout_success_message"),
				color: "blue",
				autoClose: 3e3
			}), c?.();
		} finally {
			ee(!1), D();
		}
	}, [
		v,
		c,
		u,
		D,
		h
	]), ne = s(() => {
		te();
	}, [te]);
	if (!g) return null;
	let re = g.name || "", F = [];
	e && F.push({
		label: h("userMenu.profile"),
		icon: _e,
		href: r
	}), t && F.push({
		label: h("userMenu.orders"),
		icon: ge,
		href: i
	}), n && F.push({
		label: h("userMenu.finances"),
		icon: ve,
		href: a
	});
	let ie = [...F, ...o], ae = (e, t) => {
		let n = [];
		e.dividerBefore && n.push(/* @__PURE__ */ z(w.Divider, {}, `divider-before-${t}`));
		let r = e.icon, i = /* @__PURE__ */ z(w.Item, {
			leftSection: r ? /* @__PURE__ */ z(r, {
				size: 16,
				stroke: 1.5
			}) : void 0,
			onClick: e.onClick,
			component: e.href ? "a" : void 0,
			href: e.href,
			children: e.label
		}, `item-${t}`);
		return n.push(i), e.dividerAfter && n.push(/* @__PURE__ */ z(w.Divider, {}, `divider-after-${t}`)), n;
	};
	return /* @__PURE__ */ B(R, { children: [/* @__PURE__ */ B(w, {
		width: 220,
		position: "bottom-end",
		transitionProps: { transition: "pop-top-right" },
		opened: b,
		onChange: x,
		withinPortal: !0,
		children: [/* @__PURE__ */ z(w.Target, { children: /* @__PURE__ */ z(P, {
			className: gi.userButton,
			"data-opened": b || void 0,
			"aria-label": h("userMenu.menuLabel"),
			children: /* @__PURE__ */ B(S, {
				gap: "xs",
				wrap: "nowrap",
				children: [/* @__PURE__ */ z(hi, {
					src: d,
					name: re,
					size: "sm"
				}), !M && /* @__PURE__ */ B(R, { children: [/* @__PURE__ */ z(A, {
					size: "sm",
					fw: 500,
					className: gi.userName,
					lineClamp: 1,
					children: re
				}), /* @__PURE__ */ z(le, {
					size: 14,
					stroke: 1.5,
					className: gi.chevron,
					"data-opened": b || void 0
				})] })]
			})
		}) }), /* @__PURE__ */ B(w.Dropdown, { children: [
			ie.map((e, t) => ae(e, t)),
			ie.length > 0 && /* @__PURE__ */ z(w.Divider, {}),
			/* @__PURE__ */ z(w.Item, {
				color: "red",
				leftSection: /* @__PURE__ */ z(pe, {
					size: 16,
					stroke: 1.5
				}),
				onClick: N,
				disabled: y || O,
				children: h("userMenu.logout")
			}),
			m
		] })]
	}), /* @__PURE__ */ z(T, {
		opened: C,
		onClose: D,
		title: h("userMenu.logoutConfirmTitle"),
		centered: !0,
		size: "sm",
		children: /* @__PURE__ */ B(k, {
			gap: "md",
			children: [/* @__PURE__ */ z(A, {
				size: "sm",
				children: h("userMenu.logoutConfirmMessage")
			}), /* @__PURE__ */ B(S, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ z(_, {
					variant: "default",
					onClick: D,
					disabled: O,
					children: h("userMenu.cancel")
				}), /* @__PURE__ */ z(_, {
					color: "red",
					onClick: ne,
					loading: O,
					children: h("userMenu.logout")
				})]
			})]
		})
	})] });
}
//#endregion
//#region src/hooks/useIdleSession.ts
var vi = [
	"pointerdown",
	"keydown",
	"wheel",
	"touchstart"
], yi = 6e4, bi = 6e4, xi = 15e3;
function Si(e) {
	return !(e instanceof X) || e.status === 0 || e.status === 429 || e.status >= 500;
}
function Ci(e) {
	return e instanceof X && e.status === 401;
}
function wi(e = {}) {
	let { enabled: t = !0, onSessionExpired: n } = e, r = Y((e) => e.isAuthenticated), i = Mn((e) => e.deadline), a = t && r, [o, c] = f(!1), [u, p] = f(0), m = d(n), h = d(!1), g = d(i), _ = d(null), v = d(!1), y = d(!0);
	l(() => {
		m.current = n;
	}, [n]), l(() => {
		g.current = i;
	}, [i]);
	let b = s((e) => {
		h.current = e, y.current && c(e);
	}, []), x = s(async (e) => {
		if (v.current) return;
		let t = Date.now(), n = _.current;
		if (!(!e && n !== null && t - n < yi)) {
			_.current = t, v.current = !0;
			try {
				await Jn({ onSessionExpired: m.current }), b(!1);
			} catch (e) {
				Si(e) && (_.current = n);
			} finally {
				v.current = !1;
			}
		}
	}, [b]), S = s(() => {
		x(!0);
	}, [x]);
	return l(() => (y.current = !0, () => {
		y.current = !1;
	}), []), l(() => {
		if (!a) return;
		let e = () => {
			x(h.current);
		};
		for (let t of vi) document.addEventListener(t, e, {
			capture: !0,
			passive: !0
		});
		return () => {
			for (let t of vi) document.removeEventListener(t, e, { capture: !0 });
			_.current = null;
		};
	}, [a, x]), l(() => {
		if (!a) return;
		let e = () => {
			Yn({ onSessionExpired: m.current }).catch(() => {});
		}, t = () => {
			document.visibilityState === "visible" && e();
		};
		return e(), document.addEventListener("visibilitychange", t), () => {
			document.removeEventListener("visibilitychange", t);
		};
	}, [a]), l(() => {
		a || (b(!1), Mn.getState().clear());
	}, [a, b]), l(() => {
		if (!a || i === null) {
			a && b(!1);
			return;
		}
		let e = i;
		e - Nn() > bi && b(!1);
		let t = !1, n = null, r = (e) => {
			n = setTimeout(u, Math.max(0, e));
		}, o = () => r(xi), s = async () => jn((await Yn({ onSessionExpired: m.current })).idleDeadline), c = async () => {
			try {
				let n = await s();
				if (t || n !== e) return;
				b(!0), p(Math.max(0, Math.ceil((e - Nn()) / 1e3))), r(e - Nn());
			} catch (e) {
				!t && !Ci(e) && o();
			}
		}, l = async () => {
			try {
				let n = await s();
				if (t || n !== e) return;
				await Q(m.current), t || o();
			} catch (e) {
				!t && !Ci(e) && o();
			}
		};
		function u() {
			let t = Nn();
			t >= e ? l() : t >= e - bi ? h.current ? r(e - t) : c() : r(e - bi - t);
		}
		return u(), () => {
			t = !0, n && clearTimeout(n);
		};
	}, [
		a,
		i,
		b
	]), l(() => {
		if (!o) return;
		let e = () => {
			let e = g.current;
			p(e === null ? 0 : Math.max(0, Math.ceil((e - Nn()) / 1e3)));
		};
		e();
		let t = setInterval(e, 1e3);
		return () => {
			clearInterval(t);
		};
	}, [o]), {
		warningVisible: o,
		secondsLeft: u,
		stay: S
	};
}
//#endregion
//#region src/components/AuthProvider/AuthProvider.tsx
var Ti = o(null);
function Ei() {
	let e = c(Ti);
	if (!e) throw Error("useAuthContext must be used within AuthProvider");
	return e;
}
function Di({ children: e, apiBaseUrl: t, apiTimeout: n = 3e4, enableCrossTabSync: r = !0, idleSession: i = !0, refreshThreshold: a, maxRetries: o, retryBaseDelay: s, onRefreshError: c, onSessionExpired: d }) {
	let f = gr({
		refreshThreshold: a,
		maxRetries: o,
		retryBaseDelay: s,
		onRefreshError: c,
		onSessionExpired: d
	}), p = wi({
		enabled: i,
		onSessionExpired: d
	});
	u(() => {
		wt({
			baseUrl: t,
			timeout: n,
			getToken: () => Y.getState().token
		}), Et(() => Y.getState().token);
	}, [t, n]), l(() => {
		let e;
		return r && (e = sn()), () => {
			e?.();
		};
	}, [r]), l(() => (Ln(d), () => {
		Ln(void 0);
	}), [d]);
	let m = {
		...f,
		isInitialized: !0,
		idleSession: p
	};
	return /* @__PURE__ */ z(Ti.Provider, {
		value: m,
		children: e
	});
}
//#endregion
//#region src/utils/portalOAuthContext.ts
var Oi = "teletienda.oauth.portal", ki = 600 * 1e3;
function Ai(e) {
	let t = {
		...e,
		savedAt: Date.now()
	};
	try {
		sessionStorage.setItem(Oi, JSON.stringify(t));
	} catch {}
}
function ji() {
	try {
		sessionStorage.removeItem(Oi);
	} catch {}
}
function Mi() {
	try {
		let e = sessionStorage.getItem(Oi);
		if (sessionStorage.removeItem(Oi), !e) return null;
		let t = JSON.parse(e);
		return typeof t?.domain != "string" || typeof t?.returnUrl != "string" || typeof t.savedAt != "number" || Date.now() - t.savedAt > ki ? null : {
			domain: t.domain,
			returnUrl: t.returnUrl
		};
	} catch {
		return null;
	}
}
function Ni(e) {
	return `/portal/login?${new URLSearchParams({
		domain: e.domain,
		returnUrl: e.returnUrl
	}).toString()}`;
}
//#endregion
//#region src/utils/oauthLinkResult.ts
var Pi = "teletienda.oauth.linkResult", Fi = 60 * 1e3;
function Ii(e) {
	let t = {
		result: e,
		savedAt: Date.now()
	};
	try {
		sessionStorage.setItem(Pi, JSON.stringify(t));
	} catch {}
}
function Li() {
	try {
		let e = sessionStorage.getItem(Pi);
		if (sessionStorage.removeItem(Pi), !e) return null;
		let t = JSON.parse(e);
		if (typeof t?.savedAt != "number" || Date.now() - t.savedAt > Fi) return null;
		let n = t.result;
		return !n || typeof n != "object" || typeof n.status != "string" || typeof n.provider != "string" ? null : n;
	} catch {
		return null;
	}
}
//#endregion
//#region src/components/AuthCallbackPage/AuthCallbackPage.tsx
function Ri({ provider: e, onSuccess: t, onError: n, onCancel: r, defaultReturnUrl: i = "/", linkReturnUrl: a = "/profile", loginUrl: o = "/login" }) {
	let { t: s } = L("auth"), [c, u] = f(null), [h, g] = f(!1), [_, y] = f(!0), b = Y((e) => e.login), x = d(!1);
	l(() => {
		x.current || (x.current = !0, S());
	}, []);
	async function S() {
		try {
			let n = new URLSearchParams(window.location.search), a = n.get("code"), o = n.get("state"), c = n.get("error"), l = n.get("error_description");
			if (c === "access_denied") {
				g(!0), r?.();
				return;
			}
			if (c) throw Error(s("oauth.errors.provider_denied", { error: l || c }));
			if (!a) throw Error(s("oauth.errors.missing_code"));
			let u;
			switch (e) {
				case "google": {
					if (!o) throw Error(s("oauth.errors.missing_state"));
					let e = await ir(a, o);
					if (e.intent === "link") {
						w("google", e);
						return;
					}
					u = e;
					break;
				}
				case "telegram": {
					if (!o) throw Error(s("oauth.errors.missing_state"));
					let e = await cr(a, o);
					if (e.intent === "link") {
						w("telegram", e);
						return;
					}
					u = e;
					break;
				}
				case "facebook": throw Error(s("oauth.errors.facebook_no_redirect"));
				default: throw Error(s("oauth.errors.unknown_provider"));
			}
			let d = await Tn(u.accessToken), f = G({
				...d,
				user_guid: d.user_guid || u.user.guid,
				email: d.email || u.user.email || void 0
			});
			b(u.accessToken, u.refreshToken, u.expiresIn, f);
			let p = Mi(), m = u.returnUrl || (p ? Ni(p) : null) || i;
			t?.(m);
		} catch (e) {
			if (T(e)) {
				t?.(a);
				return;
			}
			let r = jr(e, s);
			u(r), n?.(e instanceof Error ? e : Error(r));
		} finally {
			y(!1);
		}
	}
	function w(e, n) {
		Ii({
			status: "linked",
			provider: e,
			alreadyLinked: n.alreadyLinked
		}), t?.(n.returnUrl || a);
	}
	function T(t) {
		let n = t;
		if (n?.status !== 409) return !1;
		let r = e, i = n.details?.merge_challenge;
		return n.code === "MERGE_AVAILABLE" && typeof i == "string" && i ? Ii({
			status: "merge_available",
			provider: r,
			challenge: i
		}) : Ii({
			status: "failed",
			provider: r,
			code: n.code ?? null
		}), !0;
	}
	return _ ? /* @__PURE__ */ z(v, {
		h: "100vh",
		children: /* @__PURE__ */ B(k, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ z(C, { size: "lg" }), /* @__PURE__ */ z(A, {
				c: "dimmed",
				children: s("oauth.processing")
			})]
		})
	}) : h ? /* @__PURE__ */ z(v, {
		h: "100vh",
		children: /* @__PURE__ */ z(p, {
			icon: /* @__PURE__ */ z(de, { size: 16 }),
			title: s("oauth.cancelled_title"),
			color: "gray",
			variant: "light",
			maw: 400,
			children: s("oauth.cancelled")
		})
	}) : c ? /* @__PURE__ */ z(v, {
		h: "100vh",
		children: /* @__PURE__ */ z(p, {
			icon: /* @__PURE__ */ z(F, { size: 16 }),
			title: s("oauth.error_title"),
			color: "red",
			variant: "light",
			maw: 400,
			children: /* @__PURE__ */ B(k, {
				gap: "xs",
				align: "flex-start",
				children: [/* @__PURE__ */ z(A, {
					size: "sm",
					children: c
				}), /* @__PURE__ */ z(m, {
					href: o,
					size: "sm",
					children: s("oauth.back_to_login")
				})]
			})
		})
	}) : null;
}
//#endregion
//#region src/components/WhatsAppClaimLogin/WhatsAppClaimLogin.tsx
var zi = 2e3;
function Bi({ merchantGuid: e, available: t, onAuthenticated: n, onError: r }) {
	let { t: i } = L("auth"), [a, o] = f("idle"), [c, u] = f(null), [m, h] = f(null), [g, v] = f(null), [y, x] = f(null), [C, w] = f(null), T = d(null), E = s(() => {
		T.current &&= (clearInterval(T.current), null);
	}, []);
	l(() => E, [E]);
	let D = s((e, t) => {
		E(), o("failed"), w(e), r?.(t instanceof Error ? t : Error(e));
	}, [r, E]), O = s((e, t) => {
		if (e === "confirmed") {
			E(), x(t), o("confirmed");
			return;
		}
		if (e === "expired") {
			D(i("claim.errors.expired", "El código venció. Probá de nuevo."));
			return;
		}
		e === "consumed" && D(i("claim.errors.used", "Este ingreso ya fue usado."));
	}, [
		D,
		E,
		i
	]), ee = s(async () => {
		w(null), o("waiting");
		try {
			let t = await Qn(e);
			u(t.claim_guid), h(t.code), v(t.deep_link), E(), T.current = setInterval(async () => {
				try {
					let e = await $n(t.claim_guid);
					O(e.status, e.masked_identity);
				} catch (e) {
					console.debug("[shared-auth-ui] channel-claim poll failed", e);
				}
			}, zi);
		} catch (e) {
			D(e instanceof X && e.code === "CHANNEL_CLAIM_UNAVAILABLE" ? i("claim.errors.unavailable", "Esta tienda no tiene WhatsApp disponible.") : i("claim.errors.start_failed", "No pudimos iniciar el ingreso por WhatsApp."), e);
		}
	}, [
		O,
		D,
		e,
		E,
		i
	]), j = s(async () => {
		if (c) {
			o("accepting");
			try {
				let e = await er(c);
				await n({
					accessToken: e.accessToken,
					refreshToken: e.refreshToken,
					expiresIn: e.expiresIn,
					userGuid: e.user.guid
				});
			} catch (e) {
				D(i("claim.errors.accept_failed", "No pudimos completar el ingreso."), e);
			}
		}
	}, [
		c,
		D,
		n,
		i
	]);
	return t ? a === "idle" ? /* @__PURE__ */ z(_, {
		leftSection: /* @__PURE__ */ z(se, { size: 18 }),
		variant: "default",
		onClick: ee,
		"data-testid": "whatsapp-claim-button",
		children: i("claim.button", "Ingresar con WhatsApp")
	}) : a === "failed" ? /* @__PURE__ */ B(k, {
		gap: "xs",
		children: [/* @__PURE__ */ z(p, {
			color: "red",
			"data-testid": "whatsapp-claim-error",
			children: C
		}), /* @__PURE__ */ z(_, {
			variant: "subtle",
			onClick: ee,
			children: i("claim.retry", "Probar de nuevo")
		})]
	}) : a === "confirmed" || a === "accepting" ? /* @__PURE__ */ B(k, {
		gap: "sm",
		"data-testid": "whatsapp-claim-confirm",
		children: [
			/* @__PURE__ */ z(A, {
				size: "sm",
				children: i("claim.confirm_prompt", "Recibimos tu código desde este número:")
			}),
			/* @__PURE__ */ z(A, {
				fw: 700,
				size: "lg",
				"data-testid": "whatsapp-claim-mask",
				children: y
			}),
			/* @__PURE__ */ B(S, { children: [/* @__PURE__ */ z(_, {
				onClick: j,
				loading: a === "accepting",
				"data-testid": "whatsapp-claim-accept",
				children: i("claim.accept", "Sí, soy yo")
			}), /* @__PURE__ */ z(_, {
				variant: "subtle",
				onClick: () => {
					o("failed"), w(i("claim.errors.not_me", "Ingreso cancelado. No era tu número."));
				},
				children: i("claim.not_me", "No soy yo")
			})] })
		]
	}) : /* @__PURE__ */ B(k, {
		gap: "sm",
		"data-testid": "whatsapp-claim-waiting",
		children: [
			/* @__PURE__ */ z(A, {
				size: "sm",
				children: i("claim.waiting_prompt", "Enviános este código desde tu WhatsApp:")
			}),
			/* @__PURE__ */ z(b, {
				"data-testid": "whatsapp-claim-code",
				children: m
			}),
			g && /* @__PURE__ */ z(_, {
				component: "a",
				href: g,
				target: "_blank",
				rel: "noopener noreferrer",
				leftSection: /* @__PURE__ */ z(se, { size: 18 }),
				"data-testid": "whatsapp-claim-deeplink",
				children: i("claim.open_whatsapp", "Abrir WhatsApp")
			}),
			/* @__PURE__ */ z(A, {
				size: "xs",
				c: "dimmed",
				children: i("claim.waiting_hint", "Esperando tu mensaje…")
			})
		]
	}) : null;
}
//#endregion
//#region src/components/IdleSessionWarning/IdleSessionWarning.tsx
function Vi(e) {
	let t = Math.floor(e / 60), n = e % 60;
	return `${t}:${String(n).padStart(2, "0")}`;
}
function Hi() {
	let { t: e } = L("auth"), { idleSession: t } = Ei();
	return /* @__PURE__ */ z(T, {
		opened: t.warningVisible,
		onClose: t.stay,
		title: e("idle.title"),
		centered: !0,
		withCloseButton: !1,
		closeOnClickOutside: !1,
		size: "sm",
		children: /* @__PURE__ */ B(k, {
			gap: "md",
			children: [/* @__PURE__ */ z(A, {
				role: "timer",
				"aria-live": "polite",
				children: e("idle.message", { time: Vi(t.secondsLeft) })
			}), /* @__PURE__ */ z(_, {
				onClick: t.stay,
				"data-autofocus": !0,
				children: e("idle.stay")
			})]
		})
	});
}
//#endregion
//#region src/utils/token.ts
function Ui(e) {
	try {
		let t = e.split(".");
		if (t.length !== 3) return null;
		let n = t[1], r = atob(n.replace(/-/g, "+").replace(/_/g, "/"));
		return JSON.parse(r);
	} catch {
		return null;
	}
}
function Wi(e) {
	let t = Ui(e);
	return t?.exp ? /* @__PURE__ */ new Date(t.exp * 1e3) : null;
}
function Gi(e, t = 0) {
	let n = Wi(e);
	if (!n) return !0;
	let r = t * 1e3;
	return Date.now() >= n.getTime() - r;
}
function Ki(e) {
	return Ui(e)?.sub ?? null;
}
function qi(e) {
	let t = Wi(e);
	if (!t) return 0;
	let n = t.getTime() - Date.now();
	return Math.max(0, Math.floor(n / 1e3));
}
var Ji = {
	login: {
		modal_title: "Iniciar sesión",
		page_title: "Iniciar sesión",
		page_subtitle: "Ingresa con tu cuenta",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Tu contraseña",
		submit: "Iniciar sesión",
		remember_me: "Recordarme",
		forgot_password: "¿Olvidaste tu contraseña?",
		no_account: "¿No tienes cuenta? Regístrate",
		error_title: "Error de autenticación",
		help_text: "¿Problemas para ingresar? Contacta al administrador.",
		success_title: "¡Bienvenido!",
		success_message: "Has iniciado sesión correctamente",
		or_with_email: "o con email",
		method_password: "Contraseña",
		method_code: "Código por email",
		send_code: "Enviar código de acceso",
		code: "Código de verificación",
		verify_and_sign_in: "Verificar e ingresar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado a tu email",
		errors: {
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			password_required: "La contraseña es requerida",
			invalid_credentials: "Correo o contraseña incorrectos",
			account_locked: "Tu cuenta está bloqueada. Contacta al administrador.",
			account_disabled: "Tu cuenta está deshabilitada",
			email_not_verified: "Por favor verifica tu correo electrónico",
			generic: "Ocurrió un error. Intenta de nuevo.",
			code_invalid: "El código debe tener 6 dígitos",
			code_send_failed: "Error al enviar el código. Intenta de nuevo.",
			code_expired: "Código expirado. Solicita uno nuevo.",
			code_rate_limited: "Demasiados intentos. Espera 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} intentos restantes."
		}
	},
	register: {
		modal_title: "Crear cuenta",
		page_title: "Registrarse",
		page_subtitle: "Crea tu cuenta",
		name_label: "Nombre completo",
		name_placeholder: "Juan Pérez",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar contraseña",
		confirm_password_placeholder: "Repite tu contraseña",
		terms_prefix: "Acepto los",
		terms_link: "Términos y Condiciones",
		terms_and: "y la",
		privacy_link: "Política de Privacidad",
		submit: "Crear cuenta",
		have_account: "¿Ya tienes cuenta? Inicia sesión",
		or_email: "o con email",
		error_title: "Error de registro",
		errors: {
			name_required: "El nombre es requerido",
			name_too_long: "El nombre es muy largo (máximo 100 caracteres)",
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			email_exists: "Ya existe una cuenta con este correo",
			password_min_length: "La contraseña debe tener al menos 8 caracteres",
			password_uppercase: "La contraseña debe contener al menos una mayúscula",
			password_lowercase: "La contraseña debe contener al menos una minúscula",
			password_number: "La contraseña debe contener al menos un número",
			confirm_password_required: "Confirma tu contraseña",
			passwords_mismatch: "Las contraseñas no coinciden",
			terms_required: "Debes aceptar los términos y condiciones",
			validation_error: "Error de validación. Revisa los campos.",
			rate_limited: "Demasiados intentos. Intenta más tarde.",
			generic: "Ocurrió un error. Intenta de nuevo."
		},
		verification: {
			title: "Verifica tu correo",
			message: "Hemos enviado un enlace de verificación a {{email}}. Por favor revisa tu bandeja de entrada.",
			resend_button: "Reenviar correo de verificación",
			resend_sent: "Correo enviado",
			resend_success: "Hemos reenviado el correo de verificación.",
			resend_error: "Error al reenviar. Intenta de nuevo.",
			back_to_login: "Volver a iniciar sesión"
		}
	},
	password: {
		strength: {
			label: "Fortaleza de contraseña",
			weak: "Débil",
			fair: "Regular",
			good: "Buena",
			strong: "Fuerte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Al menos una letra mayúscula",
			lowercase: "Al menos una letra minúscula",
			number: "Al menos un número"
		}
	},
	guard: {
		loading: "Verificando autenticación...",
		unauthorized_title: "Acceso Denegado",
		unauthorized_message: "No tienes permiso para acceder a esta página.",
		go_back: "Volver",
		go_home: "Ir al Inicio"
	},
	userMenu: {
		menuLabel: "Menú de usuario",
		profile: "Mi Perfil",
		orders: "Mis Pedidos",
		finances: "Mis Finanzas",
		logout: "Cerrar sesión",
		logoutConfirmTitle: "Cerrar sesión",
		logoutConfirmMessage: "¿Estás seguro de que quieres cerrar sesión?",
		cancel: "Cancelar",
		logout_success_title: "Sesión cerrada",
		logout_success_message: "Has cerrado sesión correctamente"
	},
	portal: {
		title: "Iniciar sesión en TeleTienda",
		register_title: "Crear cuenta TeleTienda",
		continue_to: "para continuar a {{domain}}",
		redirecting: "Redirigiendo a {{domain}}...",
		code_error: "Error al completar la autenticación. Por favor, inténtalo de nuevo."
	},
	oauth: {
		divider: "o continuar con",
		processing: "Iniciando sesión...",
		error_title: "Error de autenticación",
		google: {
			button: "Iniciar sesión con Google",
			signup_button: "Registrarse con Google"
		},
		facebook: {
			button: "Iniciar sesión con Facebook",
			signup_button: "Registrarse con Facebook"
		},
		telegram: {
			button: "Iniciar sesión con Telegram",
			signup_button: "Registrarse con Telegram"
		},
		errors: {
			provider_denied: "Acceso denegado: {{error}}",
			unknown_provider: "Proveedor de autenticación desconocido",
			missing_code: "Código de autorización faltante",
			popup_blocked: "La ventana emergente fue bloqueada. Permita ventanas emergentes e intente de nuevo.",
			network: "Error de red. Verifique su conexión.",
			generic: "Error de autenticación. Por favor, intente de nuevo.",
			missing_state: "Falta el parámetro de estado en el enlace de retorno",
			malformed_link: "El enlace de retorno está dañado. Iniciá sesión de nuevo.",
			session_expired: "La sesión de inicio expiró. Por favor, intentá iniciar sesión de nuevo.",
			rate_limited: "Demasiados intentos. Esperá un momento y volvé a intentar.",
			service_unavailable: "El servicio de inicio de sesión no está disponible temporalmente. No es un problema con tu cuenta.",
			facebook_no_redirect: "Facebook no soporta flujo de redirección"
		},
		cancelled_title: "Inicio de sesión cancelado",
		cancelled: "Cancelaste el inicio de sesión. Podés intentarlo de nuevo cuando quieras.",
		back_to_login: "Volver al inicio de sesión"
	},
	claim: {
		button: "Ingresar con WhatsApp",
		waiting_prompt: "Enviános este código desde tu WhatsApp:",
		open_whatsapp: "Abrir WhatsApp",
		waiting_hint: "Esperando tu mensaje…",
		confirm_prompt: "Recibimos tu código desde este número:",
		accept: "Sí, soy yo",
		not_me: "No soy yo",
		retry: "Probar de nuevo",
		errors: {
			start_failed: "No pudimos iniciar el ingreso por WhatsApp.",
			unavailable: "Esta tienda no tiene WhatsApp disponible.",
			expired: "El código venció. Probá de nuevo.",
			used: "Este ingreso ya fue usado.",
			accept_failed: "No pudimos completar el ingreso.",
			not_me: "Ingreso cancelado. No era tu número."
		}
	},
	idle: {
		title: "¿Sigues ahí?",
		message: "Se cerrará tu sesión en {{time}} por inactividad.",
		stay: "Seguir conectado"
	}
}, Yi = {
	login: {
		modal_title: "Sign in",
		page_title: "Sign in",
		page_subtitle: "Log in to your account",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Your password",
		submit: "Sign in",
		remember_me: "Remember me",
		forgot_password: "Forgot password?",
		no_account: "Don't have an account? Sign up",
		error_title: "Authentication error",
		help_text: "Having trouble signing in? Contact the administrator.",
		success_title: "Welcome!",
		success_message: "You have signed in successfully",
		or_with_email: "or with email",
		method_password: "Password",
		method_code: "Email Code",
		send_code: "Send login code",
		code: "Verification code",
		verify_and_sign_in: "Verify & Sign in",
		resend_code: "Resend code",
		code_sent: "Code sent to your email",
		errors: {
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			password_required: "Password is required",
			invalid_credentials: "Invalid email or password",
			account_locked: "Your account is locked. Contact the administrator.",
			account_disabled: "Your account is disabled",
			email_not_verified: "Please verify your email address",
			generic: "An error occurred. Please try again.",
			code_invalid: "Code must be 6 digits",
			code_send_failed: "Failed to send code. Please try again.",
			code_expired: "Code expired. Please request a new one.",
			code_rate_limited: "Too many attempts. Please wait 5 minutes.",
			code_invalid_value: "Invalid code. {{remaining}} attempts remaining."
		}
	},
	register: {
		modal_title: "Create account",
		page_title: "Sign up",
		page_subtitle: "Create your account",
		name_label: "Full name",
		name_placeholder: "John Doe",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Minimum 8 characters",
		confirm_password_label: "Confirm password",
		confirm_password_placeholder: "Repeat your password",
		terms_prefix: "I accept the",
		terms_link: "Terms and Conditions",
		terms_and: "and the",
		privacy_link: "Privacy Policy",
		submit: "Create account",
		have_account: "Already have an account? Sign in",
		or_email: "or with email",
		error_title: "Registration error",
		errors: {
			name_required: "Name is required",
			name_too_long: "Name is too long (maximum 100 characters)",
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			email_exists: "An account with this email already exists",
			password_min_length: "Password must be at least 8 characters",
			password_uppercase: "Password must contain at least one uppercase letter",
			password_lowercase: "Password must contain at least one lowercase letter",
			password_number: "Password must contain at least one number",
			confirm_password_required: "Please confirm your password",
			passwords_mismatch: "Passwords do not match",
			terms_required: "You must accept the terms and conditions",
			validation_error: "Validation error. Please check the fields.",
			rate_limited: "Too many attempts. Please try again later.",
			generic: "An error occurred. Please try again."
		},
		verification: {
			title: "Verify your email",
			message: "We've sent a verification link to {{email}}. Please check your inbox.",
			resend_button: "Resend verification email",
			resend_sent: "Email sent",
			resend_success: "We've resent the verification email.",
			resend_error: "Failed to resend. Please try again.",
			back_to_login: "Back to sign in"
		}
	},
	password: {
		strength: {
			label: "Password strength",
			weak: "Weak",
			fair: "Fair",
			good: "Good",
			strong: "Strong"
		},
		requirements: {
			length: "Minimum 8 characters",
			uppercase: "At least one uppercase letter",
			lowercase: "At least one lowercase letter",
			number: "At least one number"
		}
	},
	guard: {
		loading: "Checking authentication...",
		unauthorized_title: "Access Denied",
		unauthorized_message: "You don't have permission to access this page.",
		go_back: "Go Back",
		go_home: "Go Home"
	},
	userMenu: {
		menuLabel: "User menu",
		profile: "My Profile",
		orders: "My Orders",
		finances: "My Finances",
		logout: "Log out",
		logoutConfirmTitle: "Log out",
		logoutConfirmMessage: "Are you sure you want to log out?",
		cancel: "Cancel",
		logout_success_title: "Logged out",
		logout_success_message: "You have logged out successfully"
	},
	portal: {
		title: "Sign in to TeleTienda",
		register_title: "Create TeleTienda Account",
		continue_to: "to continue to {{domain}}",
		redirecting: "Redirecting to {{domain}}...",
		code_error: "Failed to complete authentication. Please try again."
	},
	oauth: {
		divider: "or continue with",
		processing: "Signing you in...",
		error_title: "Authentication Failed",
		google: {
			button: "Sign in with Google",
			signup_button: "Sign up with Google"
		},
		facebook: {
			button: "Sign in with Facebook",
			signup_button: "Sign up with Facebook"
		},
		telegram: {
			button: "Log in with Telegram",
			signup_button: "Sign up with Telegram"
		},
		errors: {
			provider_denied: "Access was denied by {{error}}",
			unknown_provider: "Unknown authentication provider",
			missing_code: "Missing authorization code",
			popup_blocked: "Popup was blocked. Please allow popups and try again.",
			network: "Network error. Please check your connection.",
			generic: "Authentication failed. Please try again.",
			missing_state: "The return link is missing its state parameter",
			malformed_link: "The return link is damaged. Please sign in again.",
			session_expired: "Your sign-in session expired. Please try signing in again.",
			rate_limited: "Too many attempts. Please wait a moment and try again.",
			service_unavailable: "The sign-in service is temporarily unavailable. This is not a problem with your account.",
			facebook_no_redirect: "Facebook does not support the redirect flow"
		},
		cancelled_title: "Sign-in cancelled",
		cancelled: "You cancelled the sign-in. You can try again whenever you like.",
		back_to_login: "Back to sign in"
	},
	claim: {
		button: "Log in with WhatsApp",
		waiting_prompt: "Send us this code from your WhatsApp:",
		open_whatsapp: "Open WhatsApp",
		waiting_hint: "Waiting for your message…",
		confirm_prompt: "We received your code from this number:",
		accept: "Yes, that's me",
		not_me: "That's not me",
		retry: "Try again",
		errors: {
			start_failed: "We could not start the WhatsApp login.",
			unavailable: "This store has no WhatsApp available.",
			expired: "The code expired. Please try again.",
			used: "This login has already been used.",
			accept_failed: "We could not complete the login.",
			not_me: "Login cancelled. That was not your number."
		}
	},
	idle: {
		title: "Still there?",
		message: "You will be signed out in {{time}} because of inactivity.",
		stay: "Stay signed in"
	}
}, Xi = {
	login: {
		modal_title: "Вход",
		page_title: "Вход в систему",
		page_subtitle: "Войдите в свой аккаунт",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Ваш пароль",
		submit: "Войти",
		remember_me: "Запомнить меня",
		forgot_password: "Забыли пароль?",
		no_account: "Нет аккаунта? Зарегистрируйтесь",
		error_title: "Ошибка авторизации",
		help_text: "Проблемы со входом? Свяжитесь с администратором.",
		success_title: "Добро пожаловать!",
		success_message: "Вы успешно вошли в систему",
		or_with_email: "или по email",
		method_password: "Пароль",
		method_code: "Код на email",
		send_code: "Отправить код входа",
		code: "Код подтверждения",
		verify_and_sign_in: "Подтвердить и войти",
		resend_code: "Отправить код ещё раз",
		code_sent: "Код отправлен на ваш email",
		errors: {
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			password_required: "Пароль обязателен",
			invalid_credentials: "Неверный email или пароль",
			account_locked: "Ваш аккаунт заблокирован. Свяжитесь с администратором.",
			account_disabled: "Ваш аккаунт отключен",
			email_not_verified: "Пожалуйста, подтвердите ваш email",
			generic: "Произошла ошибка. Попробуйте снова.",
			code_invalid: "Код должен содержать 6 цифр",
			code_send_failed: "Не удалось отправить код. Попробуйте снова.",
			code_expired: "Код истёк. Запросите новый.",
			code_rate_limited: "Слишком много попыток. Подождите 5 минут.",
			code_invalid_value: "Неверный код. Осталось попыток: {{remaining}}."
		}
	},
	register: {
		modal_title: "Создать аккаунт",
		page_title: "Регистрация",
		page_subtitle: "Создайте свой аккаунт",
		name_label: "Полное имя",
		name_placeholder: "Иван Иванов",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Минимум 8 символов",
		confirm_password_label: "Подтвердите пароль",
		confirm_password_placeholder: "Повторите пароль",
		terms_prefix: "Я принимаю",
		terms_link: "Условия использования",
		terms_and: "и",
		privacy_link: "Политику конфиденциальности",
		submit: "Создать аккаунт",
		have_account: "Уже есть аккаунт? Войти",
		or_email: "или по email",
		error_title: "Ошибка регистрации",
		errors: {
			name_required: "Имя обязательно",
			name_too_long: "Имя слишком длинное (максимум 100 символов)",
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			email_exists: "Аккаунт с таким email уже существует",
			password_min_length: "Пароль должен содержать минимум 8 символов",
			password_uppercase: "Пароль должен содержать хотя бы одну заглавную букву",
			password_lowercase: "Пароль должен содержать хотя бы одну строчную букву",
			password_number: "Пароль должен содержать хотя бы одну цифру",
			confirm_password_required: "Подтвердите пароль",
			passwords_mismatch: "Пароли не совпадают",
			terms_required: "Вы должны принять условия использования",
			validation_error: "Ошибка валидации. Проверьте поля.",
			rate_limited: "Слишком много попыток. Попробуйте позже.",
			generic: "Произошла ошибка. Попробуйте снова."
		},
		verification: {
			title: "Подтвердите email",
			message: "Мы отправили ссылку для подтверждения на {{email}}. Проверьте вашу почту.",
			resend_button: "Отправить письмо повторно",
			resend_sent: "Письмо отправлено",
			resend_success: "Мы повторно отправили письмо для подтверждения.",
			resend_error: "Не удалось отправить. Попробуйте снова.",
			back_to_login: "Вернуться к входу"
		}
	},
	password: {
		strength: {
			label: "Надежность пароля",
			weak: "Слабый",
			fair: "Средний",
			good: "Хороший",
			strong: "Надежный"
		},
		requirements: {
			length: "Минимум 8 символов",
			uppercase: "Хотя бы одна заглавная буква",
			lowercase: "Хотя бы одна строчная буква",
			number: "Хотя бы одна цифра"
		}
	},
	guard: {
		loading: "Проверка аутентификации...",
		unauthorized_title: "Доступ Запрещен",
		unauthorized_message: "У вас нет прав для доступа к этой странице.",
		go_back: "Назад",
		go_home: "На Главную"
	},
	userMenu: {
		menuLabel: "Меню пользователя",
		profile: "Мой Профиль",
		orders: "Мои Заказы",
		finances: "Мои Финансы",
		logout: "Выйти",
		logoutConfirmTitle: "Выход из системы",
		logoutConfirmMessage: "Вы уверены, что хотите выйти?",
		cancel: "Отмена",
		logout_success_title: "Вы вышли",
		logout_success_message: "Вы успешно вышли из системы"
	},
	portal: {
		title: "Вход в TeleTienda",
		register_title: "Создать аккаунт TeleTienda",
		continue_to: "для продолжения на {{domain}}",
		redirecting: "Перенаправление на {{domain}}...",
		code_error: "Не удалось завершить авторизацию. Пожалуйста, попробуйте снова."
	},
	oauth: {
		divider: "или продолжить через",
		processing: "Выполняется вход...",
		error_title: "Ошибка аутентификации",
		google: {
			button: "Войти через Google",
			signup_button: "Зарегистрироваться через Google"
		},
		facebook: {
			button: "Войти через Facebook",
			signup_button: "Зарегистрироваться через Facebook"
		},
		telegram: {
			button: "Войти через Telegram",
			signup_button: "Зарегистрироваться через Telegram"
		},
		errors: {
			provider_denied: "Доступ запрещен: {{error}}",
			unknown_provider: "Неизвестный провайдер аутентификации",
			missing_code: "Отсутствует код авторизации",
			popup_blocked: "Всплывающее окно заблокировано. Разрешите всплывающие окна и попробуйте снова.",
			network: "Ошибка сети. Проверьте подключение.",
			generic: "Ошибка аутентификации. Попробуйте снова.",
			missing_state: "В ссылке возврата отсутствует параметр state",
			malformed_link: "Ссылка возврата повреждена. Войдите заново.",
			session_expired: "Сессия входа истекла. Пожалуйста, попробуйте войти ещё раз.",
			rate_limited: "Слишком много попыток. Подождите немного и попробуйте снова.",
			service_unavailable: "Сервис входа временно недоступен. Это не проблема с вашим аккаунтом.",
			facebook_no_redirect: "Facebook не поддерживает redirect-флоу"
		},
		cancelled_title: "Вход отменён",
		cancelled: "Вы отменили вход. Можно попробовать снова в любой момент.",
		back_to_login: "Вернуться к входу"
	},
	claim: {
		button: "Войти через WhatsApp",
		waiting_prompt: "Отправьте нам этот код со своего WhatsApp:",
		open_whatsapp: "Открыть WhatsApp",
		waiting_hint: "Ждём ваше сообщение…",
		confirm_prompt: "Мы получили ваш код с этого номера:",
		accept: "Да, это я",
		not_me: "Это не я",
		retry: "Попробовать снова",
		errors: {
			start_failed: "Не удалось начать вход через WhatsApp.",
			unavailable: "У этого магазина нет WhatsApp.",
			expired: "Код истёк. Попробуйте снова.",
			used: "Этот вход уже использован.",
			accept_failed: "Не удалось завершить вход.",
			not_me: "Вход отменён. Это был не ваш номер."
		}
	},
	idle: {
		title: "Вы ещё здесь?",
		message: "Из-за бездействия сеанс завершится через {{time}}.",
		stay: "Остаться"
	}
}, Zi = {
	login: {
		modal_title: "Entrar",
		page_title: "Entrar",
		page_subtitle: "Acesse sua conta",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Sua senha",
		submit: "Entrar",
		remember_me: "Lembrar-me",
		forgot_password: "Esqueceu a senha?",
		no_account: "Não tem conta? Cadastre-se",
		error_title: "Erro de autenticação",
		help_text: "Problemas para entrar? Entre em contato com o administrador.",
		success_title: "Bem-vindo!",
		success_message: "Você entrou com sucesso",
		or_with_email: "ou com e-mail",
		method_password: "Senha",
		method_code: "Código por e-mail",
		send_code: "Enviar código de acesso",
		code: "Código de verificação",
		verify_and_sign_in: "Verificar e entrar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado para seu e-mail",
		errors: {
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			password_required: "A senha é obrigatória",
			invalid_credentials: "E-mail ou senha incorretos",
			account_locked: "Sua conta está bloqueada. Entre em contato com o administrador.",
			account_disabled: "Sua conta está desativada",
			email_not_verified: "Por favor, verifique seu e-mail",
			generic: "Ocorreu um erro. Tente novamente.",
			code_invalid: "O código deve ter 6 dígitos",
			code_send_failed: "Erro ao enviar o código. Tente novamente.",
			code_expired: "Código expirado. Solicite um novo.",
			code_rate_limited: "Muitas tentativas. Aguarde 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} tentativas restantes."
		}
	},
	register: {
		modal_title: "Criar conta",
		page_title: "Cadastrar",
		page_subtitle: "Crie sua conta",
		name_label: "Nome completo",
		name_placeholder: "João Silva",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar senha",
		confirm_password_placeholder: "Repita sua senha",
		terms_prefix: "Eu aceito os",
		terms_link: "Termos e Condições",
		terms_and: "e a",
		privacy_link: "Política de Privacidade",
		submit: "Criar conta",
		have_account: "Já tem uma conta? Entrar",
		or_email: "ou com e-mail",
		error_title: "Erro de cadastro",
		errors: {
			name_required: "O nome é obrigatório",
			name_too_long: "O nome é muito longo (máximo 100 caracteres)",
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			email_exists: "Já existe uma conta com este e-mail",
			password_min_length: "A senha deve ter pelo menos 8 caracteres",
			password_uppercase: "A senha deve conter pelo menos uma letra maiúscula",
			password_lowercase: "A senha deve conter pelo menos uma letra minúscula",
			password_number: "A senha deve conter pelo menos um número",
			confirm_password_required: "Por favor, confirme sua senha",
			passwords_mismatch: "As senhas não coincidem",
			terms_required: "Você deve aceitar os termos e condições",
			validation_error: "Erro de validação. Verifique os campos.",
			rate_limited: "Muitas tentativas. Tente novamente mais tarde.",
			generic: "Ocorreu um erro. Tente novamente."
		},
		verification: {
			title: "Verifique seu e-mail",
			message: "Enviamos um link de verificação para {{email}}. Por favor, verifique sua caixa de entrada.",
			resend_button: "Reenviar e-mail de verificação",
			resend_sent: "E-mail enviado",
			resend_success: "Reenviamos o e-mail de verificação.",
			resend_error: "Falha ao reenviar. Tente novamente.",
			back_to_login: "Voltar para entrar"
		}
	},
	password: {
		strength: {
			label: "Força da senha",
			weak: "Fraca",
			fair: "Regular",
			good: "Boa",
			strong: "Forte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Pelo menos uma letra maiúscula",
			lowercase: "Pelo menos uma letra minúscula",
			number: "Pelo menos um número"
		}
	},
	guard: {
		loading: "Verificando autenticação...",
		unauthorized_title: "Acesso Negado",
		unauthorized_message: "Você não tem permissão para acessar esta página.",
		go_back: "Voltar",
		go_home: "Ir para Início"
	},
	userMenu: {
		menuLabel: "Menu do usuário",
		profile: "Meu Perfil",
		orders: "Meus Pedidos",
		finances: "Minhas Finanças",
		logout: "Sair",
		logoutConfirmTitle: "Sair",
		logoutConfirmMessage: "Tem certeza de que deseja sair?",
		cancel: "Cancelar",
		logout_success_title: "Sessão encerrada",
		logout_success_message: "Você saiu com sucesso"
	},
	portal: {
		title: "Entrar na TeleTienda",
		register_title: "Criar conta TeleTienda",
		continue_to: "para continuar em {{domain}}",
		redirecting: "Redirecionando para {{domain}}...",
		code_error: "Falha ao completar a autenticação. Por favor, tente novamente."
	},
	oauth: {
		divider: "ou continuar com",
		processing: "Entrando...",
		error_title: "Falha na autenticação",
		google: {
			button: "Entrar com Google",
			signup_button: "Cadastrar com Google"
		},
		facebook: {
			button: "Entrar com Facebook",
			signup_button: "Cadastrar com Facebook"
		},
		telegram: {
			button: "Entrar com Telegram",
			signup_button: "Cadastrar com Telegram"
		},
		errors: {
			provider_denied: "Acesso negado: {{error}}",
			unknown_provider: "Provedor de autenticação desconhecido",
			missing_code: "Código de autorização ausente",
			popup_blocked: "A janela pop-up foi bloqueada. Permita pop-ups e tente novamente.",
			network: "Erro de rede. Verifique sua conexão.",
			generic: "Falha na autenticação. Tente novamente.",
			missing_state: "Falta o parâmetro de estado no link de retorno",
			malformed_link: "O link de retorno está danificado. Faça login novamente.",
			session_expired: "A sessão de login expirou. Por favor, tente entrar novamente.",
			rate_limited: "Muitas tentativas. Aguarde um momento e tente novamente.",
			service_unavailable: "O serviço de login está temporariamente indisponível. Não é um problema com sua conta.",
			facebook_no_redirect: "O Facebook não suporta o fluxo de redirecionamento"
		},
		cancelled_title: "Login cancelado",
		cancelled: "Você cancelou o login. Pode tentar novamente quando quiser.",
		back_to_login: "Voltar ao login"
	},
	claim: {
		button: "Entrar com WhatsApp",
		waiting_prompt: "Envie este código pelo seu WhatsApp:",
		open_whatsapp: "Abrir WhatsApp",
		waiting_hint: "Aguardando sua mensagem…",
		confirm_prompt: "Recebemos seu código deste número:",
		accept: "Sim, sou eu",
		not_me: "Não sou eu",
		retry: "Tentar novamente",
		errors: {
			start_failed: "Não foi possível iniciar o login pelo WhatsApp.",
			unavailable: "Esta loja não tem WhatsApp disponível.",
			expired: "O código expirou. Tente novamente.",
			used: "Este login já foi usado.",
			accept_failed: "Não foi possível concluir o login.",
			not_me: "Login cancelado. Não era o seu número."
		}
	},
	idle: {
		title: "Você ainda está aí?",
		message: "Sua sessão será encerrada em {{time}} por inatividade.",
		stay: "Continuar conectado"
	}
}, Qi = [
	"es",
	"en",
	"ru",
	"pt"
], $i = "es", ea = {
	es: { auth: Ji },
	en: { auth: Yi },
	ru: { auth: Xi },
	pt: { auth: Zi }
};
function ta(e) {
	return ea[e];
}
function na(e) {
	for (let t of Qi) e.addResourceBundle(t, "auth", ea[t].auth, !0, !1);
}
//#endregion
export { qt as AUTH_STORAGE_NAME, X as AuthApiError, Ri as AuthCallbackPage, pi as AuthGuard, Di as AuthProvider, Pe as COOKIE_MAX_AGE, mt as COOKIE_MAX_SIZE, pt as COOKIE_WARNING_THRESHOLD, je as CROSS_SUBDOMAIN_SYNC_COOKIE, Ne as CROSS_SUBDOMAIN_SYNC_INTERVAL, $i as DEFAULT_LANGUAGE, Pr as FacebookLoginButton, Nr as GoogleLoginButton, Hi as IdleSessionWarning, ii as LoadingFallback, Vr as LoginForm, Wr as LoginModal, Gr as LoginPage, Pi as OAUTH_LINK_RESULT_KEY, e as PLATFORM_ADMIN_ROLES, Oi as PORTAL_OAUTH_CONTEXT_KEY, Fe as PRODUCTION_DOMAIN, Zr as PasswordStrengthIndicator, mi as ProtectedRoute, ai as RETURN_URL_PARAM, $r as RegisterForm, ti as RegisterModal, ke as SHARED_COOKIE_OK_KEY, dt as SLIM_AUTH_COOKIE_NAME, Oe as STORAGE_KEY, Qi as SUPPORTED_LANGUAGES, Ae as SYNC_CHANNEL_NAME, Rr as SocialLoginButtons, Lr as TelegramLoginButton, ri as UnauthorizedFallback, hi as UserAvatar, _i as UserMenu, ei as VerificationSuccess, Bi as WhatsAppClaimLogin, er as acceptChannelClaimApi, na as addAuthTranslations, Ke as areCookiesEnabled, qn as authFetch, ea as authTranslations, ct as broadcastCrossSubdomainLogin, lt as broadcastCrossSubdomainLogout, ut as broadcastCrossSubdomainTokenRefresh, et as broadcastLogin, tt as broadcastLogout, nt as broadcastTokenRefresh, ci as buildRedirectUrl, qr as calculatePasswordStrength, Kr as checkPasswordRequirements, Dt as checkStorageHealth, hn as clearAuthStorage, ji as clearPortalOAuthContext, Rt as clearSharedSessionIf, wt as configureAuthApi, Gn as configureHttpClient, Li as consumeOAuthLinkResult, Mi as consumePortalOAuthContext, Qt as createAuthStoreSlice, Hn as createAuthenticatedClient, Kt as createZustandStorage, Ui as decodeToken, Ge as deleteCookie, xt as deleteSlimCookie, jr as describeOAuthError, Lt as endExplicitLogout, De as envCookieName, ar as facebookOAuthCallbackApi, Tn as fetchUserProfileApi, W as getApiClient, Tt as getApiConfig, Ee as getAuthEnv, J as getAuthStorage, ta as getAuthTranslations, $n as getChannelClaimApi, V as getCookie, Je as getCookieJSON, vt as getCookieSizeInfo, at as getCrossSubdomainSync, Ze as getCrossTabSync, ui as getCurrentPath, Bn as getFreshAccessToken, Kn as getHttpClient, Ft as getOwnedRefreshToken, li as getReturnUrl, Yn as getSessionPolicy, ft as getSlimAuthCookieName, H as getSlimCookie, Be as getStorageConfig, gn as getStorageHealth, Jr as getStrengthColor, Yr as getStrengthLabel, Me as getSyncCookieName, Wi as getTokenExpiration, qi as getTokenTTL, Ki as getUserGuidFromToken, tr as googleOAuthCallbackApi, ir as googleOidcCallbackApi, jt as hasFullUserData, bt as hasSlimCookie, At as hydrateFromApi, sn as initAuthSync, Mt as isHydrationNeeded, gt as isLegacySlimData, Ot as isPrivateBrowsing, fi as isRedirectLoop, _n as isSessionPending, ht as isSlimAuthData, mn as isTokenExpired, Gi as isTokenExpiredFromString, si as isValidReturnUrl, yn as loginApi, wn as loginByCodeApi, zr as loginSchema, Sn as logoutApi, It as markExplicitLogout, q as markSessionTransition, pn as needsTokenRefresh, $e as onAuthSync, st as onCrossSubdomainSync, Ue as parseCookies, di as performRedirect, Ni as portalReturnPath, xn as refreshTokenApi, bn as registerApi, Qr as registerSchema, Pt as releaseSessionOwnership, Cn as requestLoginCodeApi, Gt as resetAuthStorage, ot as resetCrossSubdomainSync, Qe as resetCrossTabSync, Fn as resetHttpClientState, He as resetStorageConfig, Te as resolveAuthEnv, on as retryInitialHydration, Ii as saveOAuthLinkResult, Ai as savePortalOAuthContext, We as setCookie, qe as setCookieJSON, yt as setSlimCookie, Xt as setStorageAdapter, Ve as setStorageConfig, Et as setTokenGetter, Qn as startChannelClaimApi, rr as startGoogleLinkOidcApi, nr as startGoogleOidcApi, sr as startTelegramLinkOidcApi, or as startTelegramOidcApi, cr as telegramOidcCallbackApi, G as transformApiUser, Xn as updateSessionPolicy, lr as useAuth, Ei as useAuthContext, dr as useAuthGuard, Y as useAuthStore, _r as useFacebookAuth, ur as useHasHydrated, gr as useTokenRefresh };

//# sourceMappingURL=index.es.js.map